var _defs, _path, _path2, _g, _g2, _g3, _g4, _g5, _g6, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _rect, _rect2, _rect3, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _ellipse, _ellipse2, _ellipse3, _ellipse4, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _g7, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _rect4, _rect5, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _polygon, _path69, _polygon2, _polygon3, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _path184, _path185, _path186, _path187, _path188, _path189, _path190, _path191, _path192, _path193, _path194, _path195, _path196, _path197, _path198, _path199, _path200, _path201, _path202, _path203, _path204, _path205, _path206, _path207, _path208, _path209, _path210, _path211, _path212, _path213;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgKnowledgeBulb(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 423.56 274.3",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;}.cls-2{opacity:0.5;fill:url(#linear-gradient);}.cls-3{opacity:0.26;fill:url(#linear-gradient-2);}.cls-4{opacity:0.66;}.cls-5{fill:url(#linear-gradient-3);}.cls-11,.cls-18,.cls-6{fill:#fff;}.cls-6{opacity:0.47;}.cls-7{opacity:0.74;}.cls-8{fill:url(#linear-gradient-4);}.cls-9{opacity:0.75;}.cls-10{fill:url(#linear-gradient-5);}.cls-11{opacity:0.54;}.cls-12{opacity:0.4;}.cls-13{fill:url(#linear-gradient-6);}.cls-14{fill:url(#linear-gradient-7);}.cls-15{fill:url(#linear-gradient-8);}.cls-16{fill:url(#linear-gradient-9);}.cls-17{fill:url(#linear-gradient-10);}.cls-19{fill:url(#linear-gradient-11);}.cls-20{fill:url(#linear-gradient-12);}.cls-21{fill:url(#linear-gradient-13);}.cls-22{fill:url(#linear-gradient-14);}.cls-23{fill:url(#linear-gradient-15);}.cls-24{fill:url(#linear-gradient-16);}.cls-25{fill:url(#linear-gradient-17);}.cls-26{fill:url(#linear-gradient-18);}.cls-27{fill:url(#linear-gradient-19);}.cls-28{fill:url(#linear-gradient-20);}.cls-29{fill:url(#linear-gradient-21);}.cls-30{fill:url(#linear-gradient-22);}.cls-31{fill:url(#linear-gradient-23);}.cls-32{fill:url(#linear-gradient-24);}.cls-33{fill:url(#linear-gradient-25);}.cls-34{fill:url(#linear-gradient-26);}.cls-35{clip-path:url(#clip-path);}.cls-36{fill:url(#linear-gradient-28);}.cls-37{fill:url(#linear-gradient-29);}.cls-38{fill:url(#linear-gradient-30);}.cls-39{fill:url(#linear-gradient-31);}.cls-40{fill:url(#linear-gradient-32);}.cls-41{fill:url(#linear-gradient-33);}.cls-42{fill:url(#linear-gradient-34);}.cls-43{fill:url(#linear-gradient-35);}.cls-44{fill:url(#linear-gradient-36);}.cls-45{fill:url(#linear-gradient-37);}.cls-46{fill:url(#linear-gradient-38);}.cls-47{fill:url(#linear-gradient-39);}.cls-48{fill:url(#linear-gradient-40);}.cls-49{fill:url(#linear-gradient-41);}.cls-50{fill:url(#linear-gradient-42);}.cls-51{fill:url(#linear-gradient-43);}.cls-52{fill:url(#linear-gradient-44);}.cls-53{fill:url(#linear-gradient-45);}.cls-54{fill:url(#linear-gradient-46);}.cls-55{fill:url(#linear-gradient-47);}.cls-56{fill:url(#linear-gradient-48);}.cls-57{fill:url(#linear-gradient-49);}.cls-58{fill:url(#linear-gradient-50);}.cls-59{fill:url(#linear-gradient-51);}.cls-60{fill:url(#linear-gradient-52);}.cls-61{fill:url(#linear-gradient-53);}.cls-62{fill:url(#linear-gradient-54);}.cls-63{fill:url(#linear-gradient-55);}.cls-64{fill:url(#linear-gradient-56);}.cls-65{fill:url(#linear-gradient-57);}.cls-66{fill:url(#linear-gradient-58);}.cls-67{fill:url(#linear-gradient-59);}.cls-68{fill:url(#linear-gradient-60);}.cls-69{fill:url(#linear-gradient-61);}.cls-70{fill:url(#linear-gradient-62);}.cls-71{fill:url(#linear-gradient-63);}.cls-72{fill:url(#linear-gradient-64);}.cls-73{fill:url(#linear-gradient-65);}.cls-74{fill:url(#linear-gradient-66);}.cls-75{fill:url(#linear-gradient-67);}.cls-76{fill:url(#linear-gradient-68);}.cls-77{fill:url(#linear-gradient-69);}.cls-78{fill:url(#linear-gradient-70);}.cls-79{fill:url(#linear-gradient-71);}.cls-80{fill:url(#linear-gradient-72);}.cls-81{fill:#676795;}.cls-82{fill:url(#linear-gradient-73);}.cls-83{fill:url(#linear-gradient-74);}.cls-84{fill:url(#linear-gradient-75);}.cls-85{fill:url(#linear-gradient-76);}.cls-86{fill:url(#linear-gradient-77);}.cls-87{fill:url(#linear-gradient-78);}.cls-88{fill:url(#linear-gradient-79);}.cls-89{fill:url(#linear-gradient-80);}.cls-90{fill:url(#linear-gradient-81);}.cls-91{fill:url(#linear-gradient-82);}.cls-92{fill:url(#linear-gradient-83);}.cls-93{fill:url(#linear-gradient-84);}.cls-94{fill:url(#linear-gradient-85);}.cls-95{fill:url(#linear-gradient-86);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 85.86,
    y1: 222.85,
    x2: 501.78,
    y2: 222.85,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#937db9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#da99c4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: -1647.46,
    y1: 222.68,
    x2: -1271.85,
    y2: 222.68,
    gradientTransform: "matrix(-1, 0, 0, 1, -1175.35, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 277.88,
    y1: 298.33,
    x2: 222.95,
    y2: 209.83,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#6cc9f0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3c519f"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: -319.4,
    y1: 793.23,
    x2: -161.76,
    y2: 793.23,
    gradientTransform: "translate(174.61 -567.51) rotate(-19.42)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#7c4997"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ea4b7b"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 104.13,
    y1: 313.05,
    x2: 274.25,
    y2: 313.05,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: -2068.84,
    y1: -303.14,
    x2: -2124.5,
    y2: -163.68,
    gradientTransform: "matrix(-0.93, -0.36, -0.36, 0.93, -1644.12, -281.07)",
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: -2378.71,
    y1: 67.6,
    x2: -2221.07,
    y2: 67.6,
    gradientTransform: "matrix(-0.94, -0.33, -0.33, 0.94, -1744.66, -567.51)",
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    x1: -2203.91,
    y1: 208.66,
    x2: -2033.79,
    y2: 208.66,
    gradientTransform: "matrix(-0.99, -0.16, -0.16, 0.99, -1657.73, -212.07)",
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-9",
    x1: 159.17,
    y1: 326.62,
    x2: 273.22,
    y2: 338.06,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-10",
    x1: 159.3,
    y1: 334.38,
    x2: 321.36,
    y2: 334.38,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#cc246e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4c266c"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-11",
    x1: 185.59,
    y1: 160.21,
    x2: 165.55,
    y2: 219.55,
    xlinkHref: "#linear-gradient-10"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-12",
    x1: 158.43,
    y1: 170.93,
    x2: 95.2,
    y2: 259.19,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-13",
    x1: 166.17,
    y1: 176.24,
    x2: 102.12,
    y2: 265.64,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-14",
    x1: 426.77,
    y1: 197.73,
    x2: 419.28,
    y2: 249.25,
    xlinkHref: "#linear-gradient-10"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-15",
    x1: 297.08,
    y1: 310.28,
    x2: 334.06,
    y2: 370.45,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-16",
    x1: 302.48,
    y1: 310.65,
    x2: 336.9,
    y2: 366.65,
    gradientTransform: "translate(27.83 -24.36) rotate(4.61)",
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-17",
    x1: 305.87,
    y1: 308.56,
    x2: 340.29,
    y2: 364.56,
    gradientTransform: "translate(27.22 -24.39) rotate(4.61)",
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-18",
    x1: 309.26,
    y1: 306.48,
    x2: 343.68,
    y2: 362.48,
    gradientTransform: "translate(26.61 -24.41) rotate(4.61)",
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-19",
    x1: 312.65,
    y1: 304.4,
    x2: 347.07,
    y2: 360.4,
    gradientTransform: "translate(26 -24.44) rotate(4.61)",
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-20",
    x1: 313.64,
    y1: 345.96,
    x2: 287.69,
    y2: 440.48,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-21",
    x1: 312.68,
    y1: 345.69,
    x2: 286.73,
    y2: 440.22,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-22",
    x1: 310.26,
    y1: 345.03,
    x2: 284.32,
    y2: 439.55,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-23",
    x1: 309.62,
    y1: 344.85,
    x2: 283.67,
    y2: 439.38,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-24",
    x1: 317.61,
    y1: 163.88,
    x2: 309.66,
    y2: 379.93,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f7ea4a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#d93d66"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-25",
    x1: 331.62,
    y1: 239.79,
    x2: 337.44,
    y2: 424.87,
    xlinkHref: "#linear-gradient-24"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-26",
    x1: 299.53,
    y1: 240.8,
    x2: 305.35,
    y2: 425.88,
    xlinkHref: "#linear-gradient-24"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path",
    transform: "translate(-85.86 -86.78)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M314.9,311.82c-9.72,0-18-4.1-24.51-12.19-5.95-7.36-9.37-16.61-11.19-23.07a59.58,59.58,0,0,0-10.7-20.89c-9.28-11.7-25.13-36.33-27.06-69.93-1-18,4.43-33.93,15.81-46,13-13.81,33.65-22,55.14-22,2.34,0,4.7.1,7,.29,23,1.93,44.71,12.68,58.17,28.77A63,63,0,0,1,392.08,194c-2.55,27.16-17.53,48-29.65,60.63a70.39,70.39,0,0,0-16.85,29.84c-2.06,7.45-5.13,13.51-9.12,18a27.21,27.21,0,0,1-19.79,9.27C316.07,311.81,315.48,311.82,314.9,311.82Z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-28",
    x1: 358.56,
    y1: 205.4,
    x2: 440.37,
    y2: 78.95,
    xlinkHref: "#linear-gradient-24"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-29",
    x1: 362.01,
    y1: 147.82,
    x2: 407.78,
    y2: 91.17,
    xlinkHref: "#linear-gradient-24"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-30",
    x1: 416.01,
    y1: 181.69,
    x2: 244.94,
    y2: 348.76,
    xlinkHref: "#linear-gradient-24"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-31",
    x1: 287.76,
    y1: 237.88,
    x2: 342.68,
    y2: 120.02,
    xlinkHref: "#linear-gradient-24"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-32",
    x1: 320.16,
    y1: 198.58,
    x2: 391.11,
    y2: 92.16,
    xlinkHref: "#linear-gradient-24"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-33",
    x1: 316.98,
    y1: 222.94,
    x2: 280.36,
    y2: 298.47,
    xlinkHref: "#linear-gradient-24"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-34",
    x1: 240.6,
    y1: 237.68,
    x2: 306.97,
    y2: 143.85,
    xlinkHref: "#linear-gradient-24"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-35",
    x1: 295.62,
    y1: 314.57,
    x2: 335.3,
    y2: 314.57,
    gradientTransform: "matrix(-1, 0, 0, 1, 572.08, 0)",
    xlinkHref: "#linear-gradient-24"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-36",
    x1: 250.01,
    y1: 224.59,
    x2: 247.28,
    y2: 298.87,
    xlinkHref: "#linear-gradient-24"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-37",
    x1: 333.09,
    y1: 284.7,
    x2: 331.36,
    y2: 331.71,
    xlinkHref: "#linear-gradient-24"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-38",
    x1: 374.99,
    y1: 269.01,
    x2: 372.68,
    y2: 331.74,
    xlinkHref: "#linear-gradient-24"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-39",
    x1: 292.44,
    y1: 271.39,
    x2: 290.22,
    y2: 331.78,
    xlinkHref: "#linear-gradient-24"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-40",
    x1: 384.49,
    y1: 224.33,
    x2: 382.18,
    y2: 287.23,
    xlinkHref: "#linear-gradient-24"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-41",
    x1: 318.19,
    y1: 175.02,
    x2: 389.14,
    y2: 310.62,
    xlinkHref: "#linear-gradient-24"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-42",
    x1: -1698.04,
    y1: 153.18,
    x2: -1691.35,
    y2: 169.97,
    gradientTransform: "matrix(-1, 0, 0, 1, -1476.02, 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#2a3780"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#201d3f"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-43",
    x1: -1711.85,
    y1: 162.88,
    x2: -1699.49,
    y2: 191.01,
    gradientTransform: "matrix(-1, 0, 0, 1, -1476.02, 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f9b877"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ef7a62"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-44",
    x1: -1673.58,
    y1: 260.67,
    x2: -1667.9,
    y2: 260.67,
    gradientTransform: "matrix(-1, 0, 0, 1, -1476.02, 0)",
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-45",
    x1: -1697.56,
    y1: 283.05,
    x2: -1689.39,
    y2: 187.59,
    xlinkHref: "#linear-gradient-43"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-46",
    x1: -1699.94,
    y1: 259.63,
    x2: -1690.76,
    y2: 259.63,
    gradientTransform: "matrix(-1, 0, 0, 1, -1476.02, 0)",
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-47",
    x1: -1681.13,
    y1: 284.47,
    x2: -1672.96,
    y2: 188.99,
    xlinkHref: "#linear-gradient-43"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-48",
    x1: -1699.95,
    y1: 176.27,
    x2: -1671.77,
    y2: 274.13,
    gradientTransform: "matrix(-1, 0, 0, 1, -1476.02, 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f7ea4a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#e67b59"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#d93d66"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-49",
    x1: -1703.79,
    y1: 177.37,
    x2: -1675.61,
    y2: 275.24,
    xlinkHref: "#linear-gradient-48"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-50",
    x1: -1698.45,
    y1: 188.96,
    x2: -1696.92,
    y2: 177.73,
    xlinkHref: "#linear-gradient-43"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-51",
    x1: -1702.33,
    y1: 174.49,
    x2: -1688.94,
    y2: 150.66,
    xlinkHref: "#linear-gradient-43"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-52",
    x1: -1699.45,
    y1: 153.74,
    x2: -1692.75,
    y2: 170.53,
    xlinkHref: "#linear-gradient-42"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-53",
    x1: -1699.48,
    y1: 176.09,
    x2: -1686.09,
    y2: 152.26,
    xlinkHref: "#linear-gradient-43"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-54",
    x1: -1715.18,
    y1: 161.95,
    x2: -1706.64,
    y2: 181.38,
    xlinkHref: "#linear-gradient-43"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-55",
    x1: 233.39,
    y1: 166.13,
    x2: 276.36,
    y2: 166.13,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-56",
    x1: 275.69,
    y1: 162.06,
    x2: 275.69,
    y2: 162.06,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#7c4997"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-57",
    x1: 5076.83,
    y1: 3112.16,
    x2: 5096.27,
    y2: 3112.16,
    gradientTransform: "matrix(0.45, 0.89, 0.89, -0.45, -4827.9, -2974.62)",
    xlinkHref: "#linear-gradient-43"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-58",
    x1: 6750.69,
    y1: 284.34,
    x2: 6627.75,
    y2: 424.33,
    gradientTransform: "translate(-6505.69)",
    xlinkHref: "#linear-gradient-42"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-59",
    x1: 6739.05,
    y1: 274.12,
    x2: 6616.11,
    y2: 414.11,
    gradientTransform: "translate(-6505.69)",
    xlinkHref: "#linear-gradient-42"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-60",
    x1: 6656.69,
    y1: 309.64,
    x2: 6697.12,
    y2: 309.64,
    gradientTransform: "translate(-6505.69)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#abdbe4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#aadae2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-61",
    x1: 6680.73,
    y1: 309.64,
    x2: 6721.15,
    y2: 309.64,
    xlinkHref: "#linear-gradient-60"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-62",
    x1: 6693.2,
    y1: 263.65,
    x2: 6730.98,
    y2: 263.65,
    xlinkHref: "#linear-gradient-60"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-63",
    x1: 6689.65,
    y1: 277.87,
    x2: 6715.27,
    y2: 277.87,
    xlinkHref: "#linear-gradient-60"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-64",
    x1: 6683.02,
    y1: 295.18,
    x2: 6707.12,
    y2: 295.18,
    gradientTransform: "translate(-6591.55 -86.78)",
    xlinkHref: "#linear-gradient-60"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-65",
    x1: 6675.86,
    y1: 312.49,
    x2: 6699.96,
    y2: 312.49,
    gradientTransform: "translate(-6591.55 -86.78)",
    xlinkHref: "#linear-gradient-60"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-66",
    x1: 6667.59,
    y1: 329.8,
    x2: 6693.21,
    y2: 329.8,
    xlinkHref: "#linear-gradient-60"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-67",
    x1: 6660.33,
    y1: 347.11,
    x2: 6685.95,
    y2: 347.11,
    xlinkHref: "#linear-gradient-60"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-68",
    x1: 9593.29,
    y1: 358.13,
    x2: 9600.71,
    y2: 358.13,
    gradientTransform: "matrix(-1, 0, 0, 1, 10014.79, 0)",
    xlinkHref: "#linear-gradient-42"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-69",
    x1: 9594.04,
    y1: 354.68,
    x2: 9597.05,
    y2: 354.68,
    gradientTransform: "matrix(-1, 0, 0, 1, 10014.79, 0)",
    xlinkHref: "#linear-gradient-43"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-70",
    x1: 9609.07,
    y1: 358.01,
    x2: 9620.71,
    y2: 358.01,
    gradientTransform: "matrix(-1, 0, 0, 1, 10014.79, 0)",
    xlinkHref: "#linear-gradient-42"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-71",
    x1: 9609.24,
    y1: 353.35,
    x2: 9612.23,
    y2: 353.35,
    gradientTransform: "matrix(-1, 0, 0, 1, 10014.79, 0)",
    xlinkHref: "#linear-gradient-43"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-72",
    x1: 9592.17,
    y1: 326.8,
    x2: 9612.57,
    y2: 326.8,
    gradientTransform: "matrix(-1, 0, 0, 1, 10014.79, 0)",
    xlinkHref: "#linear-gradient-42"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-73",
    x1: -3936.54,
    y1: 268.91,
    x2: -3924.42,
    y2: 288.18,
    gradientTransform: "translate(4327.39)",
    xlinkHref: "#linear-gradient-24"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-74",
    x1: 9629.26,
    y1: 265.73,
    x2: 9640.38,
    y2: 265.73,
    gradientTransform: "matrix(-1, 0, 0, 1, 10014.79, 0)",
    xlinkHref: "#linear-gradient-43"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-75",
    x1: -3931.99,
    y1: 283.7,
    x2: -3876.24,
    y2: 326.69,
    gradientTransform: "translate(4327.39)",
    xlinkHref: "#linear-gradient-24"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-76",
    x1: 9654.44,
    y1: 268.16,
    x2: 9630.41,
    y2: 298.05,
    gradientTransform: "matrix(-1, 0, 0, 1, 10014.79, 0)",
    xlinkHref: "#linear-gradient-43"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-77",
    x1: 9659,
    y1: 271.82,
    x2: 9634.97,
    y2: 301.71,
    gradientTransform: "matrix(-1, 0, 0, 1, 10014.79, 0)",
    xlinkHref: "#linear-gradient-43"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-78",
    x1: 9627.41,
    y1: 250.09,
    x2: 9604.14,
    y2: 292.85,
    gradientTransform: "matrix(-1, 0, 0, 1, 10014.79, 0)",
    xlinkHref: "#linear-gradient-43"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-79",
    x1: 7427.59,
    y1: 8727.42,
    x2: 7417.31,
    y2: 8741.02,
    gradientTransform: "matrix(-0.82, -0.58, -0.58, 0.82, 11496.16, -2588.84)",
    xlinkHref: "#linear-gradient-43"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-80",
    x1: -3934.88,
    y1: 256.94,
    x2: -3922.38,
    y2: 280.16,
    gradientTransform: "translate(4327.39)",
    xlinkHref: "#linear-gradient-42"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-81",
    x1: 7412.53,
    y1: 8738.19,
    x2: 7420.78,
    y2: 8729.73,
    gradientTransform: "matrix(-0.82, -0.58, -0.58, 0.82, 11496.16, -2588.84)",
    xlinkHref: "#linear-gradient-43"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-82",
    x1: 334.96,
    y1: 248.15,
    x2: 374.84,
    y2: 248.15,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-83",
    x1: 19078.33,
    y1: -4785.93,
    x2: 19023.92,
    y2: -4818.91,
    gradientTransform: "matrix(-1, 0.07, 0.25, 0.89, 20508.53, 2952.15)",
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-84",
    x1: 19048.13,
    y1: -4798.12,
    x2: 18985.87,
    y2: -4863.95,
    gradientTransform: "matrix(-1, 0.07, 0.25, 0.89, 20594.39, 3038.92)",
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-85",
    x1: 19074.35,
    y1: -4786.48,
    x2: 19023.53,
    y2: -4817.28,
    gradientTransform: "matrix(-1, 0.07, 0.25, 0.89, 20508.53, 2952.15)",
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-86",
    x1: -22887.05,
    y1: -4285.28,
    x2: -22863.82,
    y2: -4292,
    gradientTransform: "translate(23472.85 2642.77) rotate(-4.26)",
    xlinkHref: "#linear-gradient-3"
  }))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Ilustracija 3") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M159.82,105.34c-32.26,26.66,10.86,60.88-11.48,75.82S33.47,225.24,126.65,283.05s95.74,96.11,162.26,59.51,61.74-43.18,116.48-18.43,112-13.76,92.51-59.45-31.84-45.12-9.63-74.3-12.52-109.92-89-47.52S275,158.67,266.56,135.34,210.8,63.2,159.82,105.34Z",
    transform: "translate(-85.86 -86.78)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M374.27,113.58c22.06,25.64,98.64-2.84,97.83,44.43-.94,55.35-76.2,71.63-51.83,110.53S417.73,351,319.8,350.22,64.33,300.58,102.28,247.55,115,191.81,113.1,168.37s17.35-74.83,93.19-32S318.39,48.66,374.27,113.58Z",
    transform: "translate(-85.86 -86.78)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-4"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M317.39,312.19s-41-8.76-60.33-55.19c-18.81-45.14-34.29-110.86-91.51-117.75a2.22,2.22,0,0,0-2.06,3.52c6.76,9.27,23.33,33.73,32.07,62C206.72,240.86,251.64,322,317.39,312.19Z",
    transform: "translate(-85.86 -86.78)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M183,152.27l.25.09.19.09.38.16c.24.1.48.22.71.33.47.23.93.46,1.38.71.91.48,1.78,1,2.64,1.56a58.13,58.13,0,0,1,5,3.56,64.05,64.05,0,0,1,8.71,8.48,76.89,76.89,0,0,1,7.11,9.82,81.65,81.65,0,0,1,5.49,10.79,100.52,100.52,0,0,1,4,11.39l.79,2.91.7,2.93c.23,1,.44,1.93.66,2.9s.43,1.92.68,2.87a178.41,178.41,0,0,0,7.22,22.53c1.43,3.68,3,7.29,4.69,10.87s3.49,7.09,5.38,10.56,3.93,6.85,6.06,10.19,4.4,6.56,6.77,9.73,4.9,6.21,7.53,9.17,5.42,5.76,8.33,8.45a94.71,94.71,0,0,0,9.19,7.52A83.83,83.83,0,0,0,287,306.17a85.28,85.28,0,0,1-10.29-6,95,95,0,0,1-9.44-7.3,116.13,116.13,0,0,1-8.61-8.29q-4.06-4.38-7.79-9.07t-7-9.66q-3.33-5-6.34-10.16c-2-3.47-3.86-7-5.61-10.57s-3.42-7.22-4.92-10.92a179.19,179.19,0,0,1-7.69-22.69c-.27-1-.51-1.94-.74-2.91l-.71-2.9-.71-2.86-.8-2.83a95.38,95.38,0,0,0-4-11,79.68,79.68,0,0,0-12.2-19.86c-1.28-1.47-2.58-2.91-4-4.26s-2.81-2.68-4.32-3.9a57.82,57.82,0,0,0-4.67-3.44c-.81-.52-1.63-1-2.47-1.5-.41-.24-.83-.46-1.25-.68l-.63-.31-.31-.14-.25-.1-.13-.06a1.32,1.32,0,0,1,1-2.45Z",
    transform: "translate(-85.86 -86.78)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    className: "cls-7"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M104.68,193.78a1.87,1.87,0,0,1,1.17-3.35c18.31.42,67.27,6.95,105.14,61.13,47.51,68,80.34,78.89,108.46,78.27,0,0-27.57,13.16-61.66,2.79C174.1,307.15,130.42,212.92,104.68,193.78Z",
    transform: "translate(-85.86 -86.78)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M129.84,205.42a74,74,0,0,1,10.28,5.41l1.24.75,1.21.8L145,214q2.38,1.65,4.75,3.33a195.85,195.85,0,0,1,17.78,14.9c5.7,5.23,11,10.92,16.16,16.64l3.77,4.4,1.89,2.21.94,1.1.91,1.13,7.23,9a233.27,233.27,0,0,0,31.81,33c1.45,1.25,2.88,2.52,4.39,3.71s3,2.43,4.46,3.61l4.56,3.5,4.63,3.39c1.55,1.13,3.14,2.21,4.7,3.31s3.18,2.13,4.77,3.19,3.22,2.07,4.86,3.05c.81.51,1.63,1,2.45,1.48s1.66,1,2.47,1.41l0,0a1.32,1.32,0,0,1-1.26,2.31c-3.47-1.86-6.76-3.86-10.05-5.94-1.62-1.05-3.25-2.1-4.86-3.18s-3.2-2.18-4.78-3.31c-6.32-4.48-12.4-9.29-18.27-14.35-3-2.48-5.79-5.14-8.63-7.77-1.41-1.33-2.77-2.72-4.15-4.07l-2.06-2.05c-.69-.68-1.34-1.4-2-2.1l-4-4.24-.5-.53-.47-.55-.95-1.1-1.91-2.2-1.9-2.2c-.31-.37-.64-.73-.94-1.1l-.9-1.14-3.61-4.56c-1.22-1.52-2.38-3-3.56-4.55l-3.53-4.55-.88-1.13-.92-1.11-1.84-2.21-3.68-4.42-3.83-4.3c-1.28-1.43-2.53-2.88-3.88-4.25l-4-4.16c-.66-.7-1.34-1.37-2-2l-2-2a191.66,191.66,0,0,0-17.29-15.17c-1.53-1.15-3.06-2.3-4.61-3.44l-2.36-1.64-1.18-.82-1.21-.78c-.8-.52-1.6-1-2.42-1.55l-2.47-1.48c-1.66-.93-3.34-1.89-5.07-2.66h0a.36.36,0,0,1-.18-.47A.34.34,0,0,1,129.84,205.42Z",
    transform: "translate(-85.86 -86.78)"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    className: "cls-9"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M109.08,280.45c24.4-3.49,90.64-4.59,165.17,64.9,0,0-103.11,16.17-168.59-55.3A5.76,5.76,0,0,1,109.08,280.45Z",
    transform: "translate(-85.86 -86.78)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M133.85,293c2.19,1.48,4.47,2.93,6.75,4.34s4.59,2.8,6.91,4.15q7,4,14.13,7.77A322.1,322.1,0,0,0,191,322.73c2.49,1,5,1.94,7.54,2.89l3.8,1.35c1.26.46,2.54.89,3.82,1.31s2.55.86,3.84,1.25l3.86,1.18c1.28.39,2.58.74,3.88,1.11l1.94.54,2,.51c5.2,1.38,10.47,2.48,15.77,3.44l4,.66c1.32.22,2.66.37,4,.55l2,.27c.67.09,1.34.14,2,.21l4,.39h0a.2.2,0,0,1,.18.22.22.22,0,0,1-.22.19l-4-.33c-.67-.05-1.35-.09-2-.17l-2-.23c-1.34-.16-2.69-.28-4-.48l-4-.59c-5.33-.88-10.65-1.89-15.9-3.19l-2-.48-2-.51c-1.31-.35-2.62-.67-3.92-1.05l-3.9-1.12c-1.3-.36-2.58-.79-3.87-1.19s-2.59-.8-3.87-1.24L198,326.93c-2.55-.91-5.1-1.81-7.62-2.78a322.58,322.58,0,0,1-29.71-13q-7.26-3.62-14.36-7.58-3.54-2-7-4.06c-2.33-1.39-4.63-2.79-6.93-4.3a1.32,1.32,0,0,1,1.44-2.21h0Z",
    transform: "translate(-85.86 -86.78)"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    className: "cls-12"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M317,312.19s41-8.76,60.32-55.19c18.81-45.14,34.29-110.86,91.52-117.75a2.23,2.23,0,0,1,2.06,3.52c-6.77,9.27-23.33,33.73-32.08,62C427.61,240.86,382.7,322,317,312.19Z",
    transform: "translate(-85.86 -86.78)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M452.14,154.78l-.25.1-.31.14-.63.31c-.42.22-.84.44-1.26.68-.83.47-1.65,1-2.46,1.5a56.11,56.11,0,0,0-4.67,3.44c-1.51,1.22-2.94,2.54-4.32,3.9s-2.71,2.79-4,4.26A79.71,79.71,0,0,0,422.05,189a99.26,99.26,0,0,0-4,11l-.8,2.83-.7,2.86-.71,2.9c-.23,1-.47,1.94-.74,2.91a180.79,180.79,0,0,1-7.69,22.69c-1.51,3.7-3.18,7.33-4.92,10.92s-3.65,7.1-5.62,10.57-4.12,6.84-6.33,10.16-4.59,6.52-7,9.66-5.08,6.15-7.8,9.07a118,118,0,0,1-8.6,8.29,95.17,95.17,0,0,1-9.45,7.3,85.94,85.94,0,0,1-10.28,6,84.62,84.62,0,0,0,10.09-6.29,94.71,94.71,0,0,0,9.19-7.52q4.35-4,8.33-8.45t7.53-9.17q3.56-4.75,6.77-9.73c2.12-3.34,4.15-6.73,6.05-10.19s3.71-7,5.39-10.56,3.26-7.19,4.69-10.87a178.37,178.37,0,0,0,7.21-22.53c.25-1,.47-1.91.69-2.87s.42-1.91.66-2.9l.7-2.93.79-2.91a100.52,100.52,0,0,1,4-11.39A81.65,81.65,0,0,1,425,177.07a76.89,76.89,0,0,1,7.11-9.82,63.48,63.48,0,0,1,8.71-8.48,56.43,56.43,0,0,1,4.95-3.56c.86-.55,1.74-1.08,2.65-1.56.45-.25.91-.48,1.37-.71.24-.11.47-.23.72-.33l.37-.16.2-.09.24-.09a1.32,1.32,0,0,1,1,2.45Z",
    transform: "translate(-85.86 -86.78)"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    className: "cls-7"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M508.68,194.16a1.86,1.86,0,0,0-1.17-3.34c-18.32.41-67.27,6.94-105.14,61.12-47.51,68-80.34,78.89-108.47,78.27,0,0,27.58,13.17,61.67,2.79C439.25,307.54,482.94,213.3,508.68,194.16Z",
    transform: "translate(-85.86 -86.78)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M483.78,206.45c-1.72.77-3.4,1.73-5.07,2.66l-2.46,1.48c-.82.5-1.62,1-2.43,1.55l-1.2.78-1.18.82-2.37,1.64c-1.54,1.14-3.08,2.29-4.6,3.45A190,190,0,0,0,447.18,234l-2.06,2c-.68.68-1.37,1.34-2,2.05l-4,4.15c-1.34,1.37-2.59,2.83-3.88,4.25l-3.82,4.3-3.68,4.42-1.85,2.21-.92,1.11-.88,1.13-3.53,4.55c-1.17,1.52-2.34,3-3.55,4.55l-3.61,4.56-.9,1.14c-.31.38-.63.73-.95,1.1l-1.9,2.2-1.9,2.2-.95,1.1-.48.55-.49.53-4,4.24c-.67.7-1.31,1.43-2,2.1l-2.06,2.05c-1.39,1.36-2.74,2.74-4.15,4.07-2.84,2.63-5.67,5.29-8.64,7.78-5.87,5.05-11.95,9.86-18.27,14.34-1.57,1.13-3.19,2.2-4.78,3.31s-3.23,2.13-4.86,3.19c-3.28,2.07-6.57,4.07-10,5.94a1.32,1.32,0,0,1-1.26-2.32l0,0c.81-.45,1.65-.92,2.46-1.41s1.64-1,2.45-1.48c1.64-1,3.25-2,4.86-3.05s3.2-2.11,4.78-3.19,3.15-2.18,4.69-3.3l4.64-3.4,4.55-3.5c1.51-1.18,3-2.41,4.47-3.61s2.94-2.46,4.39-3.7a233.81,233.81,0,0,0,31.8-33.05l7.24-9,.9-1.13.95-1.1,1.88-2.21,3.78-4.4c5.21-5.72,10.45-11.41,16.16-16.64a193.15,193.15,0,0,1,17.78-14.9q2.37-1.68,4.75-3.33l2.43-1.58L472,212l1.24-.75a73.45,73.45,0,0,1,10.28-5.41.35.35,0,0,1,.28.65Z",
    transform: "translate(-85.86 -86.78)"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    className: "cls-9"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M487,304c-23.56-7.24-88.81-18.63-173.25,38.41,0,0,99.34,32,175.13-28.39A5.76,5.76,0,0,0,487,304Z",
    transform: "translate(-85.86 -86.78)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M461.71,314.92c-2.5,1.12-5,2.15-7.51,3.16s-5.05,2-7.59,2.91q-7.62,2.82-15.36,5.26a323.13,323.13,0,0,1-31.38,8.25c-2.64.57-5.3,1.06-8,1.56l-4,.68c-1.33.24-2.66.43-4,.63s-2.67.41-4,.57l-4,.5c-1.34.17-2.69.28-4,.42l-2,.21-2,.16c-5.39.47-10.8.64-16.2.67l-4.06,0c-1.35,0-2.7-.1-4.05-.14l-2-.09c-.67,0-1.35-.1-2-.14l-4-.31a.21.21,0,0,1-.19-.22.2.2,0,0,1,.22-.19h0l4,.24c.67,0,1.34.09,2,.1l2,.06c1.35,0,2.7.09,4,.07l4,0c5.38-.13,10.77-.39,16.12-.95l2-.19,2-.24c1.34-.16,2.68-.3,4-.49l4-.57c1.33-.18,2.65-.42,4-.63s2.66-.44,4-.7l4-.74c2.63-.54,5.27-1.07,7.89-1.69,10.5-2.37,20.85-5.34,31.06-8.74q7.65-2.56,15.17-5.49,3.75-1.45,7.47-3c2.47-1,4.95-2.12,7.34-3.25h0a1.32,1.32,0,1,1,1.12,2.39Z",
    transform: "translate(-85.86 -86.78)"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M163.75,349H309.44V319.8H163.75C166.86,319.8,166.86,349,163.75,349Z",
    transform: "translate(-85.86 -86.78)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M309.44,341.67V328.32c0-4.7-2.88-8.52-6.43-8.52H159.68a.38.38,0,0,1-.38-.38v-5.83a.38.38,0,0,1,.38-.38H312.37c3.48,0,9,5.46,9,12.2v18.64c0,6.36-5.35,11.51-8.63,11.51h-153a.38.38,0,0,1-.38-.38v-5.83a.39.39,0,0,1,.38-.39H303.93C307,349,309.44,345.7,309.44,341.67Z",
    transform: "translate(-85.86 -86.78)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M305.4,326.17H168.79a.38.38,0,0,1,0-.76H305.4a.38.38,0,0,1,0,.76Z",
    transform: "translate(-85.86 -86.78)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M305.4,330.5H168.79a.39.39,0,0,1,0-.77H305.4a.39.39,0,0,1,0,.77Z",
    transform: "translate(-85.86 -86.78)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M305.4,334.82H168.79a.38.38,0,0,1,0-.76H305.4a.38.38,0,0,1,0,.76Z",
    transform: "translate(-85.86 -86.78)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M305.4,339.15H168.79a.38.38,0,1,1,0-.76H305.4a.38.38,0,0,1,0,.76Z",
    transform: "translate(-85.86 -86.78)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M305.4,343.48H168.79a.38.38,0,1,1,0-.76H305.4a.38.38,0,0,1,0,.76Z",
    transform: "translate(-85.86 -86.78)"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-19",
    x: 109.68,
    y: 196.56,
    width: 117.68,
    height: 28.41,
    rx: 7.01
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-20",
    x: 122.98,
    y: 199.83,
    width: 13.83,
    height: 21.88
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-21",
    x: 138.84,
    y: 199.83,
    width: 5.19,
    height: 21.88
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M413.36,256.14s40.43-20,27.21-34.69-37.88-8.83-39.13,6.65S430.2,240,413.36,256.14Z",
    transform: "translate(-85.86 -86.78)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M437.15,225.63H419.3a.39.39,0,0,1,0-.77h17.85a.39.39,0,0,1,0,.77Z",
    transform: "translate(-85.86 -86.78)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M414,225.63h-5.29a.39.39,0,0,1,0-.77H414a.39.39,0,1,1,0,.77Z",
    transform: "translate(-85.86 -86.78)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M437.75,229.24h-6.7a.38.38,0,0,1,0-.76h6.7a.38.38,0,1,1,0,.76Z",
    transform: "translate(-85.86 -86.78)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M421.22,229.24H409.31a.38.38,0,0,1,0-.76h11.91a.38.38,0,1,1,0,.76Z",
    transform: "translate(-85.86 -86.78)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M438.35,232.85H420.54a.38.38,0,0,1,0-.76h17.81a.38.38,0,0,1,0,.76Z",
    transform: "translate(-85.86 -86.78)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M416.08,232.85h-6.17a.38.38,0,0,1,0-.76h6.17a.38.38,0,0,1,0,.76Z",
    transform: "translate(-85.86 -86.78)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M337.8,342.81c-.12,8-10.37,16.51-22.22,16.51s-20.81-6.25-21.46-14.21c-1.54-19,9.61-18.8,21.46-18.8S338.09,323.07,337.8,342.81Z",
    transform: "translate(-85.86 -86.78)"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-24",
    cx: 316.57,
    cy: 333.56,
    rx: 30.04,
    ry: 7.85,
    transform: "translate(-111.64 -60.26) rotate(-4.61)"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-25",
    cx: 316.57,
    cy: 325.97,
    rx: 30.04,
    ry: 7.85,
    transform: "translate(-111.03 -60.28) rotate(-4.61)"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-26",
    cx: 316.57,
    cy: 318.37,
    rx: 30.04,
    ry: 7.85,
    transform: "translate(-110.42 -60.3) rotate(-4.61)"
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-27",
    cx: 316.57,
    cy: 310.77,
    rx: 30.04,
    ry: 7.85,
    transform: "translate(-109.81 -60.33) rotate(-4.61)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "M308.28,342.16a70.72,70.72,0,0,1-13.12-1.08.39.39,0,0,1-.31-.46.4.4,0,0,1,.46-.32,85.09,85.09,0,0,0,21.85.69,92.78,92.78,0,0,0,18.33-3.16.4.4,0,0,1,.49.27.41.41,0,0,1-.27.5,95,95,0,0,1-18.48,3.19C314.15,342,311.15,342.16,308.28,342.16Z",
    transform: "translate(-85.86 -86.78)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "M308.37,334.55a62.65,62.65,0,0,1-16.11-1.74.4.4,0,0,1-.27-.5.4.4,0,0,1,.49-.27c5.73,1.63,15,2.14,24.68,1.36s18.6-2.73,24-5.23a.41.41,0,0,1,.53.2.39.39,0,0,1-.2.52c-5.49,2.54-14.56,4.51-24.27,5.3C314.2,334.43,311.21,334.55,308.37,334.55Z",
    transform: "translate(-85.86 -86.78)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "M308.28,327c-6.89,0-12.92-.71-17-2a.4.4,0,1,1,.25-.75c5.64,1.86,15.22,2.47,25.6,1.64,9.63-.78,18.6-2.73,24-5.23a.41.41,0,0,1,.53.2.39.39,0,0,1-.2.52c-5.49,2.54-14.56,4.52-24.27,5.3C314.15,326.84,311.14,327,308.28,327Z",
    transform: "translate(-85.86 -86.78)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M308.34,319.35a68.33,68.33,0,0,1-14.3-1.3.4.4,0,0,1-.31-.47.41.41,0,0,1,.48-.3c5.81,1.29,14.18,1.62,23,.92,9.54-.77,18.47-2.7,23.89-5.17a.39.39,0,1,1,.32.72c-5.49,2.51-14.52,4.46-24.14,5.24C314.19,319.23,311.19,319.35,308.34,319.35Z",
    transform: "translate(-85.86 -86.78)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "M275.52,277.59a55.86,55.86,0,0,0-10-19.55c-9.84-12.41-25.9-37.64-27.88-72.08-2.88-50.09,41.55-75.17,82.09-71.76s80.54,33.59,76.16,80.19c-2.7,28.67-18.75,50.42-30.69,62.91a66.3,66.3,0,0,0-15.93,28.22c-3.59,13-12.12,29.08-32.41,30.07C290.6,316.86,279.7,292.4,275.52,277.59Z",
    transform: "translate(-85.86 -86.78)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M323.56,305.6l14.18-92.26c.29-1.9,1.23-3.18,2.1-2.86s1.32,2.14,1,4.05l0,.16-16.15,91.4c-.13.69-.48,1.12-.78,1S323.45,306.26,323.56,305.6Z",
    transform: "translate(-85.86 -86.78)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    className: "cls-34",
    d: "M308.83,306.33l-14.18-92.25c-.29-1.91-1.23-3.19-2.1-2.86s-1.32,2.13-1,4l0,.16,16.15,91.4c.12.69.47,1.12.78,1S308.93,307,308.83,306.33Z",
    transform: "translate(-85.86 -86.78)"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M337.64,205.42a1.48,1.48,0,0,0-1.86-.48l-7.9,3.69-2.74-7.81a1.69,1.69,0,0,0-1-1,2,2,0,0,0-2.43.75v0l-6.5,11.85-6-16.86v0a1.92,1.92,0,0,0-.91-1,2.36,2.36,0,0,0-3,.59l-9.08,12.5a1.1,1.1,0,0,0,.32,1.58,1.53,1.53,0,0,0,1.93-.21l8-8.92,7.2,16h0a1.27,1.27,0,0,0,.63.62,1.5,1.5,0,0,0,1.89-.49l6.94-11.15,2.62,5.64,0,.05a.75.75,0,0,0,.07.12,1.49,1.49,0,0,0,1.86.49l9.37-4.38A1.12,1.12,0,0,0,337.64,205.42Z",
    transform: "translate(-85.86 -86.78)"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M365.49,244.18a.59.59,0,0,1-.34-.12.57.57,0,0,1-.11-.8,104,104,0,0,0,6.65-10.11.57.57,0,0,1,.78-.21.56.56,0,0,1,.21.78A105.87,105.87,0,0,1,366,244,.56.56,0,0,1,365.49,244.18Z",
    transform: "translate(-85.86 -86.78)"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M377.16,224.15a.44.44,0,0,1-.22-.05.56.56,0,0,1-.3-.75,87.87,87.87,0,0,0,6.72-45.7,71.52,71.52,0,0,0-4.8-19.08.57.57,0,0,1,.28-.76.58.58,0,0,1,.76.28,73.34,73.34,0,0,1,4.9,19.42,89.15,89.15,0,0,1-6.81,46.3A.57.57,0,0,1,377.16,224.15Z",
    transform: "translate(-85.86 -86.78)"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "M275.52,277.59a55.86,55.86,0,0,0-10-19.55c-9.84-12.41-25.9-37.64-27.88-72.08-2.88-50.09,41.55-75.17,82.09-71.76s80.54,33.59,76.16,80.19c-2.7,28.67-18.75,50.42-30.69,62.91a66.3,66.3,0,0,0-15.93,28.22c-3.59,13-12.12,29.08-32.41,30.07C290.6,316.86,279.7,292.4,275.52,277.59Z",
    transform: "translate(-85.86 -86.78)"
  })), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    className: "cls-35"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "M387.08,195.88a10,10,0,0,1,1.78,6.12c-.46,4.13-6.79,6-12.34,3.67-4-1.63-2.26-7-1-10a1.4,1.4,0,0,0-1.3-2H360v-16.1A1.87,1.87,0,0,1,362.7,176a18.57,18.57,0,0,0,5.52,1.93c4.36.69,8.71-4.13,8.26-8.72a9,9,0,0,0-9.41-7.79,6.78,6.78,0,0,0-3.95,1.57,1.87,1.87,0,0,1-3-1.49V147.41h15.12a1,1,0,0,0,.76-1.61c-7.3-8.66,7.36-17.08,11-11.46,2.81,4.3.76,9.2-.59,11.6a1,1,0,0,0,.85,1.47h14.65V162a1.87,1.87,0,0,1-3,1.5,9.18,9.18,0,0,0-4.8-2.06c-4.82-.46-7.57,4.12-8.52,7.79s3.24,9,7.6,8.26a44.71,44.71,0,0,0,6.5-1.61,1.87,1.87,0,0,1,2.43,1.8l-.1,16.1H388.28A1.4,1.4,0,0,0,387.08,195.88Z",
    transform: "translate(-85.86 -86.78)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M386.44,145.94c1.35-2.4,3.4-7.3.59-11.6-3.67-5.62-18.33,2.8-11,11.46a1,1,0,0,1-.76,1.61H360.12V131.13a1.87,1.87,0,0,0-2.68-1.69,23.73,23.73,0,0,1-6.65,2.15c-4.82.68-7.68-4.82-7.05-9.41s6.13-7.34,8.88-6.88a11.8,11.8,0,0,1,4.43,2.47,1.87,1.87,0,0,0,3-1.47V100.39h14.61a1.44,1.44,0,0,0,1.15-2.32c-3.06-4-1.71-9,2.47-10.52,5.05-1.84,9.63-.46,10.32,4.81a8.73,8.73,0,0,1-3.14,8h16l-.57,16a1.87,1.87,0,0,0,2.89,1.63,15.24,15.24,0,0,1,6.13-2.47c5.05-.69,9.64,3.44,9.64,7.8s-3.9,9.63-10.09,8.49a26.44,26.44,0,0,1-5-1.38,1.86,1.86,0,0,0-2.56,1.73v15.24H387.29A1,1,0,0,1,386.44,145.94Z",
    transform: "translate(-85.86 -86.78)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-38",
    d: "M388.27,234.63c1.4-2.5,1.63-6.09-4.91-9.23-9.44-4.53-11.36,4-9,9.45a2.1,2.1,0,0,1-1.92,2.94H360V224.3a1.88,1.88,0,0,0-2.59-1.74,16,16,0,0,1-5.47,1.24c-5,.22-8.83-3.9-8.07-9.64s5.64-7.11,8-6.42a24,24,0,0,1,5.17,3,1.87,1.87,0,0,0,2.94-1.54V193.75h14.29a1.4,1.4,0,0,1,1.3,2c-1.29,2.94-3,8.33,1,10,5.55,2.3,11.88.46,12.34-3.67a10,10,0,0,0-1.78-6.12,1.4,1.4,0,0,1,1.2-2.13h13.77l-.09,14a2.09,2.09,0,0,1-3.28,1.7,9.37,9.37,0,0,0-4.54-1.72c-4.13-.23-8.26,3-8.5,7.11s2.76,9.4,7.35,9.17a12.84,12.84,0,0,0,6.13-2.4,2.08,2.08,0,0,1,3.25,1.74l-.09,14.43h-12.2A2.11,2.11,0,0,1,388.27,234.63Z",
    transform: "translate(-85.86 -86.78)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M388.27,234.63Z",
    transform: "translate(-85.86 -86.78)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "M293.31,190.4c-1.95-2.83-3.86-7.87,3.23-11.73,3.69-2,8.26,1.14,8.77,6.65a10.8,10.8,0,0,1-1.05,6.07,1.39,1.39,0,0,0,1.26,2h13.6v15a1.93,1.93,0,0,0,2.9,1.67c8.91-5.15,12.69,3.16,12.54,5.24-.17,2.29-1.44,9.4-6.71,9.4a12.82,12.82,0,0,1-5.91-1.48,1.94,1.94,0,0,0-2.85,1.71v12.92h-13a2.1,2.1,0,0,0-2,2.84,17.76,17.76,0,0,1,1.25,7.64c-.46,5.5-8.17,6.88-12.11,3.67-2.92-2.37-.81-6.76.84-10.09a2.1,2.1,0,0,0-1.9-3H276.47V222.76a1.74,1.74,0,0,0-2.64-1.48,18.36,18.36,0,0,1-5.16,2.29c-3.9.91-6.67-4.13-6.89-8.26s2.76-7.11,7.58-7.34a6.92,6.92,0,0,1,4.39,1.29,1.73,1.73,0,0,0,2.72-1.42V192.59h15.68A1.4,1.4,0,0,0,293.31,190.4Z",
    transform: "translate(-85.86 -86.78)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-40",
    d: "M345.62,191.6a9,9,0,0,0,.92-7.37c-1.72-6.42-7.57-6.08-10.43-4.82-2.42,1.06-5.24,7.33-2,11.75A1.4,1.4,0,0,1,333,193.4H319.12V177.17a1.93,1.93,0,0,0-2.78-1.74,15.61,15.61,0,0,1-5.69,1.57c-5.51.46-8.12-4.36-7.85-9.17.24-4.18,6.31-9.39,12.86-4.87a1.92,1.92,0,0,0,3-1.59V147h17c-5.28,4.43-3.9,10.92,1.37,13.45s10.1.46,10.55-5.28a8.05,8.05,0,0,0-1.88-6.16,1,1,0,0,1,.74-1.64h13.69v14.08a1.87,1.87,0,0,0,3,1.49,6.78,6.78,0,0,1,3.95-1.57,9,9,0,0,1,9.41,7.79c.45,4.59-3.9,9.41-8.26,8.72A18.57,18.57,0,0,1,362.7,176a1.87,1.87,0,0,0-2.74,1.66v16.1H346.8A1.4,1.4,0,0,1,345.62,191.6Z",
    transform: "translate(-85.86 -86.78)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-41",
    d: "M294.1,241.92c-1.65,3.33-3.76,7.72-.84,10.09,3.94,3.21,11.65,1.83,12.11-3.67a17.76,17.76,0,0,0-1.25-7.64,2.1,2.1,0,0,1,2-2.84h13v15.95a1.93,1.93,0,0,0,2.89,1.68c6-3.37,13.3-2.86,12.52,7.53-.66,8.76-8.11,6.8-12.22,5a1.93,1.93,0,0,0-2.69,1.78V284.7H306.08a1.81,1.81,0,0,1-1.6-2.66c1.07-2,2.12-4.78,1.35-7.09-1.38-4.13-9.55-4.13-12.57-1.38-1.95,1.77-.55,5.87.69,8.57a1.82,1.82,0,0,1-1.65,2.57H276.47V270.16a1.73,1.73,0,0,0-2.62-1.49,12.53,12.53,0,0,1-5.64,1.69c-5,.23-6.44-7.34-6.43-10.55,0-2.89,4.1-9.32,12-3.87a1.74,1.74,0,0,0,2.74-1.42v-15.6H292.2A2.1,2.1,0,0,1,294.1,241.92Z",
    transform: "translate(-85.86 -86.78)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-42",
    d: "M251.76,194.74c-1.56,2.47-3.28,6.57-.12,9.5,4.82,4.47,11.87,1.89,12.73-3.27a8.45,8.45,0,0,0-1.43-6.18,1.4,1.4,0,0,1,1.14-2.2h12.39v15.25a1.73,1.73,0,0,1-2.72,1.42,6.92,6.92,0,0,0-4.39-1.29c-4.82.23-7.8,3.21-7.58,7.34s3,9.17,6.89,8.26a18.36,18.36,0,0,0,5.16-2.29,1.74,1.74,0,0,1,2.64,1.48v16.16h-11.7a2.1,2.1,0,0,1-1.81-3.16,7.66,7.66,0,0,0,.66-6.23c-1.83-6.42-9.17-5.51-12.84-1.38-2,2.29-1,5.34.25,7.61a2.1,2.1,0,0,1-1.81,3.16H235.76v-16a1.49,1.49,0,0,1,2.15-1.34,21.84,21.84,0,0,0,7.36,2.24c5,.45,6-6,6.2-10.1.2-3.73-5.95-9.52-13.32-4a1.49,1.49,0,0,1-2.39-1.19V192.59h14.82A1.4,1.4,0,0,1,251.76,194.74Z",
    transform: "translate(-85.86 -86.78)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-43",
    d: "M250.26,287.28c-1.53,3.25-1.45,8.51.52,10.14,2.75,2.3,13.87,3.61,13.76-3.67a11.53,11.53,0,0,0-1.69-6.25,1.8,1.8,0,0,1,1.51-2.79h12.11v15.65a1.73,1.73,0,0,1-2.75,1.4,11.65,11.65,0,0,0-4.82-2.27c-3.44-.46-7.34,3.67-7.11,8s2.06,9.4,6.65,8.94a11.66,11.66,0,0,0,5.3-2,1.74,1.74,0,0,1,2.73,1.43v15.43H263.62s6.34,12-1.87,13c-7.49.83-12.32-.31-9.83-9.89a2.44,2.44,0,0,0-2.35-3.06H236.79V315.83a1.48,1.48,0,0,1,2.05-1.38,21.74,21.74,0,0,0,5.75,1.55c4.12.46,6.65-3,6.88-8.48.2-5-5.62-7.91-12.51-4.49a1.48,1.48,0,0,1-2.17-1.31v-17h11.78A1.82,1.82,0,0,1,250.26,287.28Z",
    transform: "translate(-85.86 -86.78)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M258.25,345.4c-2.61,0-5.05-.49-6.53-2.2s-1.84-4.83-.73-9.11a1.49,1.49,0,0,0-.26-1.29,1.47,1.47,0,0,0-1.16-.57H236.79a1,1,0,0,1-1-1V315.83a2.44,2.44,0,0,1,3.38-2.26,20.82,20.82,0,0,0,5.48,1.49,4.31,4.31,0,0,0,3.4-1c1.44-1.23,2.3-3.58,2.42-6.61a4.35,4.35,0,0,0-2-4c-2.25-1.47-5.65-1.32-9.09.39a2.47,2.47,0,0,1-2.4-.11,2.39,2.39,0,0,1-1.15-2.06v-17a1,1,0,0,1,1-1h11.78a2.79,2.79,0,0,1,2.38,1.32,2.72,2.72,0,0,1,.18,2.62h0c-1.39,2.95-1.25,7.74.26,9s6.85,2.32,9.91.86a3.77,3.77,0,0,0,2.29-3.78,10.74,10.74,0,0,0-1.54-5.75,2.76,2.76,0,0,1-.11-2.83,2.72,2.72,0,0,1,2.42-1.44h12.11a1,1,0,0,1,.95,1v15.65a2.69,2.69,0,0,1-4.26,2.18,10.64,10.64,0,0,0-4.39-2.11,4.66,4.66,0,0,0-3.63,1.44,7.35,7.35,0,0,0-2.4,5.6c.17,3.2,1.16,5.88,2.65,7.16a3.73,3.73,0,0,0,3,.88,10.65,10.65,0,0,0,4.86-1.89,2.73,2.73,0,0,1,2.8-.15,2.66,2.66,0,0,1,1.41,2.37v15.43a1,1,0,0,1-.95,1H265.13c1,2.37,2.72,7.2,1.1,10.27a5.23,5.23,0,0,1-4.38,2.66A31.09,31.09,0,0,1,258.25,345.4Zm-20.51-15.08h11.83a3.38,3.38,0,0,1,3.27,4.24c-.93,3.59-.82,6.07.32,7.39s3.85,1.84,8.48,1.32a3.41,3.41,0,0,0,2.9-1.66c1.42-2.68-.79-8.05-1.76-9.89a.93.93,0,0,1,0-.94,1,1,0,0,1,.81-.46h11.9V315.84a.75.75,0,0,0-.41-.68.8.8,0,0,0-.84,0,12.48,12.48,0,0,1-5.73,2.21,5.6,5.6,0,0,1-4.39-1.34c-2.71-2.32-3.22-6.72-3.31-8.5a9.25,9.25,0,0,1,3-7.1,6.58,6.58,0,0,1,5.19-1.93,12.32,12.32,0,0,1,5.24,2.45.78.78,0,0,0,1.25-.63v-14.7H264.36a.85.85,0,0,0-.75.44.86.86,0,0,0,0,.88,12.45,12.45,0,0,1,1.84,6.76,5.65,5.65,0,0,1-3.37,5.53c-3.85,1.84-9.9.59-12-1.11-2.42-2-2.4-7.82-.77-11.28h0a.8.8,0,0,0-.06-.79.91.91,0,0,0-.77-.43H237.74v16.06a.51.51,0,0,0,.24.44.55.55,0,0,0,.55,0c4.05-2,8.16-2.12,11-.28a6.26,6.26,0,0,1,2.91,5.66c-.15,3.61-1.22,6.37-3.09,8a6.18,6.18,0,0,1-4.85,1.41,22.45,22.45,0,0,1-6-1.62.53.53,0,0,0-.5.05.55.55,0,0,0-.24.45Zm12.52-43h0Z",
    transform: "translate(-85.86 -86.78)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-44",
    d: "M251,235.76c-1.29-2.27-2.28-5.32-.25-7.61,3.67-4.13,11-5,12.84,1.38a7.66,7.66,0,0,1-.66,6.23,2.1,2.1,0,0,0,1.81,3.16h11.7v15.6a1.74,1.74,0,0,1-2.74,1.42c-7.85-5.45-11.94,1-12,3.87,0,3.21,1.38,10.78,6.43,10.55a12.53,12.53,0,0,0,5.64-1.69,1.73,1.73,0,0,1,2.62,1.49v14.55H264.36a1.8,1.8,0,0,0-1.51,2.79,11.53,11.53,0,0,1,1.69,6.25c.11,7.28-11,6-13.76,3.67-2-1.63-2.05-6.89-.52-10.14a1.82,1.82,0,0,0-1.69-2.57H236.79V268.79a1.49,1.49,0,0,0-2.26-1.28,19,19,0,0,1-8.29,2.85c-5.28.23-6-5.74-6.2-10.32-.2-4.06,7.3-8.82,13.39-4.82a1.5,1.5,0,0,0,2.33-1.24V238.92h13.46A2.1,2.1,0,0,0,251,235.76Z",
    transform: "translate(-85.86 -86.78)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-45",
    d: "M316.66,313.6a16.71,16.71,0,0,1-6,2.4c-3.9.46-7.57-4.35-6.89-10.09a8.06,8.06,0,0,1,12.82-5.1,1.93,1.93,0,0,0,3-1.61V284.7H333a1.81,1.81,0,0,1,1.41,2.93c-3.84,5-4.71,12.92,4.95,12.55,8.64-.34,7-7.41,5.49-11.28a1.82,1.82,0,0,1,1.68-2.49H360v14.35a1.87,1.87,0,0,1-2.93,1.55,13,13,0,0,0-5.1-2.36c-3.44-.46-8,2.29-8,6.88s1.38,8.94,7.12,8.49a17.4,17.4,0,0,0,6.23-1.7,1.87,1.87,0,0,1,2.71,1.67v16H347.7a2.43,2.43,0,0,1-2.24-3.37,15.27,15.27,0,0,0,1.21-4.09c.46-3.67-4.83-6.18-9.19-5.83-3.43.27-7.42,5.46-5.59,10a2.41,2.41,0,0,1-2.27,3.28h-10v-16A1.94,1.94,0,0,0,316.66,313.6Z",
    transform: "translate(-85.86 -86.78)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-46",
    d: "M357.25,313.62a17.4,17.4,0,0,1-6.23,1.7c-5.74.45-7.12-3.9-7.12-8.49s4.59-7.34,8-6.88a13,13,0,0,1,5.1,2.36,1.87,1.87,0,0,0,2.93-1.55V286.41h13.73a1.8,1.8,0,0,0,1.56-2.71,12.24,12.24,0,0,1-1.53-6.46c0-7.8,9.18-11,11.77-4.59,1.72,4.26,1.16,8.92.58,11.58a1.8,1.8,0,0,0,1.77,2.18H402.4v13.92a2.09,2.09,0,0,1-3.21,1.76,20.65,20.65,0,0,0-5.17-2.6c-2.88-.69-8.14,2.52-8.37,8s2.52,7.8,8,8.25a9.51,9.51,0,0,0,5.62-1.27,2.09,2.09,0,0,1,3.1,1.85v14.92H389.09a2.42,2.42,0,0,1-2.32-3.15c1.15-3.7,1.68-9.44-5.71-10.05-9.05-.76-8.74,4.45-6.32,9.79a2.42,2.42,0,0,1-2.22,3.41H360v-16A1.87,1.87,0,0,0,357.25,313.62Z",
    transform: "translate(-85.86 -86.78)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M402.4,332H389.09a3.2,3.2,0,0,1-3-4.14c.63-2,1.12-4.9-.18-6.82-.87-1.3-2.51-2.06-4.86-2.25-3.31-.28-5.46.25-6.38,1.56s-.71,3.79.81,7.15a3.19,3.19,0,0,1-2.91,4.5H360a.76.76,0,0,1-.76-.77v-16a1.07,1.07,0,0,0-.52-.93,1.11,1.11,0,0,0-1.1-.05,17.89,17.89,0,0,1-6.5,1.77,6.9,6.9,0,0,1-5.46-1.58c-1.64-1.51-2.48-4.1-2.48-7.67a7.34,7.34,0,0,1,2.59-5.58,8.28,8.28,0,0,1,6.3-2.06,13.44,13.44,0,0,1,5.44,2.49,1.11,1.11,0,0,0,1.73-.92V286.41a.76.76,0,0,1,.76-.76h13.73a1,1,0,0,0,.92-.54,1,1,0,0,0,0-1,13,13,0,0,1-1.64-6.85,8.54,8.54,0,0,1,6.53-8.66,5.8,5.8,0,0,1,6.71,3.79c1.82,4.51,1.17,9.47.62,12a1,1,0,0,0,.21.87,1,1,0,0,0,.81.39H402.4a.76.76,0,0,1,.76.76v13.92a2.85,2.85,0,0,1-4.38,2.41,19.23,19.23,0,0,0-4.94-2.51,5.61,5.61,0,0,0-4.24,1.32,7.93,7.93,0,0,0-3.19,6c-.2,4.85,1.92,7,7.33,7.46a8.8,8.8,0,0,0,5.18-1.17,2.78,2.78,0,0,1,2.8,0,2.85,2.85,0,0,1,1.44,2.49v14.92A.76.76,0,0,1,402.4,332Zm-23-14.81c.53,0,1.09,0,1.69.08,2.83.23,4.85,1.22,6,2.92,1.63,2.42,1.1,5.75.37,8.12a1.66,1.66,0,0,0,1.59,2.16h12.54V316.35a1.32,1.32,0,0,0-.68-1.17,1.23,1.23,0,0,0-1.27,0,10.24,10.24,0,0,1-6.06,1.37c-6.19-.51-9-3.39-8.73-9a9.48,9.48,0,0,1,3.79-7.15,7,7,0,0,1,5.51-1.58,20.17,20.17,0,0,1,5.41,2.7,1.31,1.31,0,0,0,1.34.05,1.33,1.33,0,0,0,.69-1.17V287.18H387.84a2.56,2.56,0,0,1-2-1,2.52,2.52,0,0,1-.51-2.15c.51-2.38,1.12-7-.55-11.13a4.27,4.27,0,0,0-5-2.86,7,7,0,0,0-5.29,7.16,11.62,11.62,0,0,0,1.41,6.06,2.5,2.5,0,0,1,0,2.56,2.6,2.6,0,0,1-2.25,1.32h-13v13.58a2.63,2.63,0,0,1-4.12,2.17,12.3,12.3,0,0,0-4.77-2.23,6.81,6.81,0,0,0-5.1,1.69,5.82,5.82,0,0,0-2.06,4.44c0,3.13.67,5.34,2,6.55a5.44,5.44,0,0,0,4.3,1.17,16.17,16.17,0,0,0,6-1.61h0a2.66,2.66,0,0,1,2.58.12,2.62,2.62,0,0,1,1.23,2.23v15.22h11.8a1.64,1.64,0,0,0,1.4-.77,1.6,1.6,0,0,0,.12-1.57c-1.78-3.94-2-6.78-.67-8.66C374.44,318,376.47,317.23,379.44,317.23Z",
    transform: "translate(-85.86 -86.78)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "M273.74,314.41a11.66,11.66,0,0,1-5.3,2c-4.59.46-6.42-4.59-6.65-8.94s3.67-8.49,7.11-8a11.65,11.65,0,0,1,4.82,2.27,1.73,1.73,0,0,0,2.75-1.4V284.71H292.3a1.82,1.82,0,0,0,1.65-2.57c-1.24-2.7-2.64-6.8-.69-8.57,3-2.75,11.19-2.75,12.57,1.38.77,2.31-.28,5.09-1.35,7.09a1.81,1.81,0,0,0,1.6,2.66h13.51v14.5a1.93,1.93,0,0,1-3,1.61,8.06,8.06,0,0,0-12.82,5.1c-.68,5.74,3,10.55,6.89,10.09a16.71,16.71,0,0,0,6-2.4,1.94,1.94,0,0,1,2.93,1.66v16H304a2.42,2.42,0,0,1-2.2-3.46c.92-1.91,4.69-4.26,4.47-6.07-.46-3.67-8.63-4.58-13-3.9-3.36.52-1.69,5.78.22,10a2.43,2.43,0,0,1-2.21,3.44h-14.8V315.84A1.74,1.74,0,0,0,273.74,314.41Z",
    transform: "translate(-85.86 -86.78)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-48",
    d: "M386.07,284.23c.58-2.66,1.14-7.32-.58-11.58-2.59-6.42-11.77-3.21-11.77,4.59a12.24,12.24,0,0,0,1.53,6.46,1.8,1.8,0,0,1-1.56,2.71H360V270.66a1.87,1.87,0,0,0-2.82-1.61,10.81,10.81,0,0,1-5.21,1.54c-4.36,0-8.71-5.28-8-10.1s4.29-8.25,8-7.34a14.8,14.8,0,0,1,5,2.81,1.87,1.87,0,0,0,3-1.46V237.79h12.52a2.1,2.1,0,0,0,1.92-2.94c-2.4-5.45-.48-14,9-9.45,6.54,3.14,6.31,6.73,4.91,9.23a2.11,2.11,0,0,0,1.81,3.16h12.2l-.09,15.3a2.09,2.09,0,0,0,3.1,1.84,13.62,13.62,0,0,1,7.66-1.78c6.58.46,9.17,4.82,9.4,9.64s-4.59,9.86-10.32,8.49a20.15,20.15,0,0,1-6.41-2.89,2.08,2.08,0,0,0-3.22,1.76v16.26H387.84A1.8,1.8,0,0,1,386.07,284.23Z",
    transform: "translate(-85.86 -86.78)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M386.07,284.23h0Z",
    transform: "translate(-85.86 -86.78)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-49",
    d: "M345.84,234.7a12.71,12.71,0,0,0,1.28-3.75c1.32-8-8.59-6.93-12.56-2.8-2,2.11-1.34,4.58-.19,6.51a2.11,2.11,0,0,1-1.79,3.2H319.09V224.94a1.94,1.94,0,0,1,2.85-1.71,12.82,12.82,0,0,0,5.91,1.48c5.27,0,6.54-7.11,6.71-9.4.15-2.08-3.63-10.39-12.54-5.24a1.93,1.93,0,0,1-2.9-1.67v-15H333a1.4,1.4,0,0,0,1.12-2.24c-3.21-4.42-.39-10.69,2-11.75,2.86-1.26,8.71-1.6,10.43,4.82a9,9,0,0,1-.92,7.37,1.4,1.4,0,0,0,1.18,2.15H360v15.42a1.87,1.87,0,0,1-2.94,1.54,24,24,0,0,0-5.17-3c-2.38-.69-7.26.69-8,6.42s3.06,9.86,8.07,9.64a16,16,0,0,0,5.47-1.24A1.88,1.88,0,0,1,360,224.3v13.49H347.69A2.1,2.1,0,0,1,345.84,234.7Z",
    transform: "translate(-85.86 -86.78)"
  }))), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    className: "cls-50",
    d: "M218.05,162.21s-2.25,1.1-2.67,2.36c-.33,1-2.83,1.14-3.07,3.13a2.29,2.29,0,0,1-1.91,2c-2.55.39-6.48,1.71-7.11,6.14-.48,3.37,1.24,4.65,3.05,5.1a2.55,2.55,0,0,1,1.94,3c-.26,1.29.13,2.77,2.35,3.95,5,2.63,10-6.24,10-6.24l1-15.48Z",
    transform: "translate(-85.86 -86.78)"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    className: "cls-51",
    d: "M241.54,154.05s-6.42,17.49-17.36,23c0,0,3.64,5.94,5.54,6.3,0,0,11.68-14.95,12.87-27.2Z",
    transform: "translate(-85.86 -86.78)"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    className: "cls-52",
    d: "M197.55,259.31l-.33,2.65a1.09,1.09,0,0,1-1,1,16.8,16.8,0,0,1-3.55.06.94.94,0,0,1-.79-1.22,9.72,9.72,0,0,1,1.78-3.47h3A.92.92,0,0,1,197.55,259.31Z",
    transform: "translate(-85.86 -86.78)"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    className: "cls-53",
    d: "M220.6,228.22l.5,2.92s-1.66,16.86-2,23.6a5.35,5.35,0,0,0,.78,3l2.9,4.7-7.36-4.34-.14-.9,1.2-1.65-1.58-18.88a5.88,5.88,0,0,1,.66-3.21l1.52-2.85Z",
    transform: "translate(-85.86 -86.78)"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    className: "cls-54",
    d: "M223.3,263.12H221a1.42,1.42,0,0,1-1.12-.55c-.73-.95-2.24-2.8-3-2.85-1-.07-.85,3.4-.85,3.4h-.55l-.69-4.31a2.57,2.57,0,0,1,1.34-2.67h0a3.6,3.6,0,0,0,1.43,2.38c1.21.73,4.92,3.35,4.92,3.35a3.29,3.29,0,0,1,1,0A.62.62,0,0,1,223.3,263.12Z",
    transform: "translate(-85.86 -86.78)"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    className: "cls-55",
    d: "M210.53,229.61s-9.75,18.49-11.29,22.71a40.6,40.6,0,0,0-2.12,8.08c0,.52-.68,1-2.47,1a1.7,1.7,0,0,1-1.59-.73,1,1,0,0,1,0-1c.56-1.14,2.35-4.79,3-6.44.79-2,2.49-10.92,3.42-14s2-6.48,6.06-9.59C205.52,229.61,208.31,226.87,210.53,229.61Z",
    transform: "translate(-85.86 -86.78)"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    className: "cls-56",
    d: "M216.69,199.31c2.52-10.66-3.85-16.68-3.85-16.68,4-3.86,11.34-5.62,11.34-5.62s7,5.11,6.16,9.11c-.49,2.34-4.91,14-4.91,14A9.73,9.73,0,0,1,216.69,199.31Z",
    transform: "translate(-85.86 -86.78)"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    className: "cls-57",
    d: "M211.12,204.58c1-3.08,5.57-5.27,5.57-5.27a9.73,9.73,0,0,0,8.74.85,17.65,17.65,0,0,1,.28,6.77c-.63,3.26-4.61,24.21-4.61,24.21-6.26,1.27-15.89-1.27-15.89-1.27C209.2,222.78,210.09,207.67,211.12,204.58Z",
    transform: "translate(-85.86 -86.78)"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    className: "cls-58",
    d: "M219.61,170l-2,9.19c-.2.8.54.67,1.35.52,1.34-.26,3.07-.78,3.65-1.82a.79.79,0,0,0,.1-.34l.88-6.37a1.13,1.13,0,0,0-.67-1.2l-1.69-.75A1.15,1.15,0,0,0,219.61,170Z",
    transform: "translate(-85.86 -86.78)"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    className: "cls-59",
    d: "M222,161.23a9.06,9.06,0,0,1,4.07,4.52c1.64,3.5.41,5.11-1.13,5.34a7.25,7.25,0,0,1-6.3-2.08C216.21,166.75,218.86,160,222,161.23Z",
    transform: "translate(-85.86 -86.78)"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    className: "cls-60",
    d: "M220.29,167.15S218.47,162,223,162l1.06.74s1.67-2.84-1.06-4.19-5.94-.24-7.1,3.45-1.36,6.14.57,7.9,2.74-.23,2.74-.23-1.06-1.65-.63-2.53,1.42.18,1.42.18Z",
    transform: "translate(-85.86 -86.78)"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    className: "cls-61",
    d: "M219.79,167.72s-.93-2.64-2.16-1.59,1,2.43,1.88,2.88Z",
    transform: "translate(-85.86 -86.78)"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    className: "cls-62",
    d: "M242.15,157.23c.1.31-1,.79-1.7-.49,0-.61-.4-3.22,0-3.72,1.94-2.65,4-2.82,4-2.82a8.9,8.9,0,0,1,1.07,2.11,2.57,2.57,0,0,1-.26,1.88c-.32.58-.76,1.33-1.17,1.92A2.53,2.53,0,0,1,242.15,157.23Z",
    transform: "translate(-85.86 -86.78)"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    className: "cls-63",
    d: "M275.31,162.72c-1.69-1-5.17-2.41-8.22-.42-4,2.6,2,13,8.11,7.82a.7.7,0,0,1,1.16.53v8.08a2.64,2.64,0,0,1-2.64,2.64h-8.9a1.32,1.32,0,0,0-1.2,1.89,17,17,0,0,1,1.52,4.72c.49,3.42-3.41,5.44-6.66,5s-5.2-4.35-4.88-6.3a8.57,8.57,0,0,1,1.75-3.14,1.32,1.32,0,0,0-1-2.14h-8.85A2.42,2.42,0,0,1,243,179V171a1,1,0,0,0-1.65-.81c-2.85,2.16-6.38,1.21-7.46-1.75-1.3-3.58-.32-6.83,3.42-7.32a6.18,6.18,0,0,1,5.69,2.23v-9.14a2.14,2.14,0,0,1,2.21-2.14l9.11.33a1.32,1.32,0,0,0,1.15-2.05,10.94,10.94,0,0,1-1.75-4.35c-.48-3.57,2.44-6.82,5.53-6.82a6.09,6.09,0,0,1,6,7.15,18.73,18.73,0,0,1-1,3.55,1.31,1.31,0,0,0,1.23,1.81h8.16a2.65,2.65,0,0,1,2.64,2.65v7.73A.7.7,0,0,1,275.31,162.72Z",
    transform: "translate(-85.86 -86.78)"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    className: "cls-64",
    d: "M275.69,162.06Z",
    transform: "translate(-85.86 -86.78)"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    className: "cls-65",
    d: "M211.71,185.46s18.7,22.84,32.67-3.16a3.22,3.22,0,0,0,.1-1.63,14.86,14.86,0,0,1,.41-3.08.47.47,0,0,0-.43-.57h0a.62.62,0,0,0-.58.25l-2.56,3.25a1.35,1.35,0,0,0,.73,1.61h0a.68.68,0,0,1,.24,1c-10.62,13.93-28.39-1.36-28.72-1.18C212.42,182.61,211.09,183.31,211.71,185.46Z",
    transform: "translate(-85.86 -86.78)"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    className: "cls-66",
    d: "M223,355.58a.76.76,0,0,1-.76-.76V263.88a.76.76,0,1,1,1.52,0v90.94A.76.76,0,0,1,223,355.58Z",
    transform: "translate(-85.86 -86.78)"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    className: "cls-67",
    d: "M202.42,355.58a.76.76,0,0,1-.76-.76V263.88a.76.76,0,1,1,1.52,0v90.94A.76.76,0,0,1,202.42,355.58Z",
    transform: "translate(-85.86 -86.78)"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    className: "cls-68",
    d: "M151.77,356.16a.8.8,0,0,1-.3-.06.76.76,0,0,1-.4-1L190,263.58a.77.77,0,0,1,1-.4.76.76,0,0,1,.4,1l-38.9,91.51A.78.78,0,0,1,151.77,356.16Z",
    transform: "translate(-85.86 -86.78)"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    className: "cls-69",
    d: "M175.8,356.16a.8.8,0,0,1-.3-.06.76.76,0,0,1-.4-1L214,263.58a.77.77,0,0,1,1-.4.76.76,0,0,1,.4,1l-38.9,91.51A.78.78,0,0,1,175.8,356.16Z",
    transform: "translate(-85.86 -86.78)"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    className: "cls-70",
    d: "M224.22,264.72H188.58a1.07,1.07,0,0,1-1.07-1.07h0a1.07,1.07,0,0,1,1.07-1.08h35.64a1.07,1.07,0,0,1,1.07,1.08h0A1.07,1.07,0,0,1,224.22,264.72Z",
    transform: "translate(-85.86 -86.78)"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    className: "cls-71",
    d: "M208.82,278.64h-24.1a.77.77,0,0,1,0-1.53h24.1a.77.77,0,1,1,0,1.53Z",
    transform: "translate(-85.86 -86.78)"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-72",
    x: 91.47,
    y: 207.65,
    width: 24.1,
    height: 1.52
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-73",
    x: 84.31,
    y: 224.95,
    width: 24.1,
    height: 1.52
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    className: "cls-74",
    d: "M186.76,330.56h-24.1a.76.76,0,0,1,0-1.52h24.1a.76.76,0,1,1,0,1.52Z",
    transform: "translate(-85.86 -86.78)"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    className: "cls-75",
    d: "M179.5,347.87H155.4a.77.77,0,0,1,0-1.53h24.1a.77.77,0,0,1,0,1.53Z",
    transform: "translate(-85.86 -86.78)"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    className: "cls-76",
    d: "M420.47,355.51s.82,1.3,1,4.94a.59.59,0,0,1-.59.63h-6.44a.38.38,0,0,1-.37-.5,10.33,10.33,0,0,1,4.07-5.4Z",
    transform: "translate(-85.86 -86.78)"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    className: "cls-77",
    d: "M420.75,353.05l-.36,3.06a.58.58,0,0,1-.51.5,5.17,5.17,0,0,1-1.36,0,1,1,0,0,1-.78-.94v-3Z",
    transform: "translate(-85.86 -86.78)"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    className: "cls-78",
    d: "M404.52,355.18a9.07,9.07,0,0,1,1.21,4.55,1.14,1.14,0,0,1-1.15,1.11h-10a.48.48,0,0,1-.28-.87,43.48,43.48,0,0,1,8.31-4.79Z",
    transform: "translate(-85.86 -86.78)"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    className: "cls-79",
    d: "M405.55,351.88l-.78,3.77a.78.78,0,0,1-.92.61,2.6,2.6,0,0,1-.88-.36.91.91,0,0,1-.4-.92l.81-4.57Z",
    transform: "translate(-85.86 -86.78)"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    className: "cls-80",
    d: "M419.32,299.37s2.71,2.39,3.21,5.25-1.44,49.5-1.44,49.5-2.7.45-4.1-.4c0,0-1.65-30.26-2.91-37.25,0,0-6.59,31.35-8.41,37,0,0-2.61.32-3.45-.18,0,0,1.73-40.63,3.9-47.85Z",
    transform: "translate(-85.86 -86.78)"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    className: "cls-81",
    d: "M414.16,315.48h-.07a.29.29,0,0,1-.2-.35l1.14-4.4a.31.31,0,0,1,.13-.17l2.48-1.6a.29.29,0,0,1,.31.49L415.56,311l-1.12,4.3A.29.29,0,0,1,414.16,315.48Z",
    transform: "translate(-85.86 -86.78)"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    className: "cls-82",
    d: "M392.63,272.43c11.39-.95,14.36,1.41,14.36,1.41l-5.47,8.64s-11.18-.22-19.2-6.4a19.7,19.7,0,0,0,3.21-4.79A15.07,15.07,0,0,0,392.63,272.43Z",
    transform: "translate(-85.86 -86.78)"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    className: "cls-83",
    d: "M374.8,255.72a.35.35,0,0,1,.67-.13l1.45,3.1a3.24,3.24,0,0,1,.26,1.92l-.51,1.8a3.12,3.12,0,0,0,.64,2.48,21.56,21.56,0,0,0,8.22,6.4,19.7,19.7,0,0,1-3.21,4.79,19.62,19.62,0,0,1-6.83-9.49,1.52,1.52,0,0,1-1.08-1.51Z",
    transform: "translate(-85.86 -86.78)"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    className: "cls-84",
    d: "M388.89,277.44c4-4.32,11.64-6.27,16.06-7.07a4.05,4.05,0,0,1,4.53,2.57c2,5.34,7.4,19.25,8.45,21.65.86,2,1.75,3.87,2.33,5.07a1.44,1.44,0,0,1-.68,1.92,105,105,0,0,1-13.12,4.61.93.93,0,0,1-1.19-.9,2.91,2.91,0,0,0-.41-1.49l-10.28-17.12c-6.4,7.1-12,7.74-16.32,6.19a32.22,32.22,0,0,0,1.43-6.73C386.05,285.05,388.89,277.44,388.89,277.44Z",
    transform: "translate(-85.86 -86.78)"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    className: "cls-85",
    d: "M369.17,285l1.15-1.53c3.72,2.55,6.82,3.16,9.37,2.72a32.22,32.22,0,0,1-1.43,6.73C372.59,290.82,369.17,285,369.17,285Z",
    transform: "translate(-85.86 -86.78)"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    className: "cls-86",
    d: "M370,285l-6.47.25-6-3.33c.86-.53,5.69.56,5.69.56s5.06-.76,6.43-.76c1.13,0,1,1.63.88,2.18l0,.18Z",
    transform: "translate(-85.86 -86.78)"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    className: "cls-87",
    d: "M398.87,262.43l3.41,8.34s-3.92,2.71-7.08,2.45l-1.7-7.49Z",
    transform: "translate(-85.86 -86.78)"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    className: "cls-88",
    d: "M393.1,256.76c-.08.11-2.47,8.75-2.47,8.75l5,1.26,3.49-7.86S394.41,254.9,393.1,256.76Z",
    transform: "translate(-85.86 -86.78)"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    className: "cls-89",
    d: "M397.21,260.11l-1.51,4.27a.8.8,0,0,1-.08.16c-.21.29-1,1.24-1.91.38a5.8,5.8,0,0,0-2.33-1.6.64.64,0,0,0-.72.46,26.78,26.78,0,0,0-.83,4.17.63.63,0,0,0,.51.68,20.71,20.71,0,0,0,4.74.39.61.61,0,0,0,.53-.36c.48-1,1.93-4.17,2.46-5s1.75-.74,2.27-.7a.62.62,0,0,0,.47-.15,1.65,1.65,0,0,0,.1-2.64.63.63,0,0,1,0-.91,1.63,1.63,0,0,0,.21-2.44,2.32,2.32,0,0,0-2.77-.67.62.62,0,0,1-.76-.28.5.5,0,0,0-.52-.24.62.62,0,0,1-.66-.64,1.89,1.89,0,0,0-1.46-2c-2.17-.68-3.52,1.42-3.66,3s2.26,2.16,3.67,2.05c1.07-.08,1.86,1,2.18,1.5A.64.64,0,0,1,397.21,260.11Z",
    transform: "translate(-85.86 -86.78)"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    className: "cls-90",
    d: "M397.51,265.23s.35-2.71,1.48-2.85,2.22.8,1.1,2.32C398.7,266.59,397.51,265.23,397.51,265.23Z",
    transform: "translate(-85.86 -86.78)"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    className: "cls-91",
    d: "M372.8,243.09a7,7,0,0,0-6.17-1c-5.42,1.46-5.23,6.77-4.22,9.39.85,2.2,6.07,4.86,9.83,2a1.17,1.17,0,0,1,1.86,1.05l-.23,12.55-13.62-.25a1.75,1.75,0,0,0-1.51,2.49,14.92,14.92,0,0,1,1.23,5.19c.29,5-3.8,7.28-7.83,7-3.5-.28-7.78-5.86-3.87-11.72A1.76,1.76,0,0,0,347,267l-12-.23.28-15.38c3.64,4.85,9.11,3.7,11.31-1s.56-9.14-4.25-9.65a6.46,6.46,0,0,0-5.2,1.62.82.82,0,0,1-1.36-.7l.23-12.41,11.81.22a1.7,1.7,0,0,0,1.3-2.69,6.51,6.51,0,0,1-1.25-3.61c-.12-4.16,2.84-8.06,6.7-8.4s7.82,3.68,7.17,7.62a17.79,17.79,0,0,1-1.71,5,1.7,1.7,0,0,0,1.34,2.51l13.51.25L374.62,242A1.18,1.18,0,0,1,372.8,243.09Z",
    transform: "translate(-85.86 -86.78)"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-92",
    points: "337.02 58.19 339.91 70.14 346.77 63.05 337.02 58.19"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    className: "cls-93",
    d: "M475,125.13l-25.45,36.11a3.12,3.12,0,0,1-4.43.68L409.81,135a1.25,1.25,0,0,1,.61-2.23Z",
    transform: "translate(-85.86 -86.78)"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-94",
    points: "337.03 58.19 389.13 38.35 342.71 62.55 343.37 65.9 337.03 58.19"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-95",
    points: "346.1 65.11 339.91 70.14 342.71 62.55 346.1 65.11"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M422.85,160.4l-1,.6a.25.25,0,0,1-.34-.08.24.24,0,0,1,.08-.33h0l1-.58a.24.24,0,0,1,.32.08A.23.23,0,0,1,422.85,160.4Z",
    transform: "translate(-85.86 -86.78)"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M419.58,162.37l-1,.58a.28.28,0,0,1-.28-.48h0l1-.56a.27.27,0,0,1,.36.1A.27.27,0,0,1,419.58,162.37Z",
    transform: "translate(-85.86 -86.78)"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M416.26,164.26l-1,.56a.3.3,0,1,1-.29-.53h0l1-.54a.31.31,0,0,1,.4.12A.29.29,0,0,1,416.26,164.26Z",
    transform: "translate(-85.86 -86.78)"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M412.91,166.09l-1,.54a.33.33,0,0,1-.3-.59h0l1-.52a.32.32,0,0,1,.43.14A.32.32,0,0,1,412.91,166.09Z",
    transform: "translate(-85.86 -86.78)"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M409.52,167.85l-1,.52a.36.36,0,1,1-.32-.64h0l1-.5h0a.33.33,0,0,1,.46.16A.34.34,0,0,1,409.52,167.85Z",
    transform: "translate(-85.86 -86.78)"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M406.09,169.55l-1,.49a.38.38,0,1,1-.33-.69h0l1-.48h0a.38.38,0,1,1,.32.68Z",
    transform: "translate(-85.86 -86.78)"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M402.63,171.18l-1,.47a.4.4,0,1,1-.33-.73h0l1.05-.47h0a.39.39,0,0,1,.52.2A.4.4,0,0,1,402.63,171.18Z",
    transform: "translate(-85.86 -86.78)"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M399.15,172.74l-1,.46a.41.41,0,0,1-.56-.22.42.42,0,0,1,.22-.56h0l1.06-.45h0a.42.42,0,0,1,.55.23A.41.41,0,0,1,399.15,172.74Z",
    transform: "translate(-85.86 -86.78)"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M395.64,174.25l-1.06.44a.44.44,0,1,1-.34-.82h0l1.06-.42h0a.44.44,0,1,1,.34.81Z",
    transform: "translate(-85.86 -86.78)"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M392.1,175.7l-1.06.43a.47.47,0,0,1-.61-.26.46.46,0,0,1,.26-.61h0l1.06-.42h0a.47.47,0,0,1,.6.27A.45.45,0,0,1,392.1,175.7Z",
    transform: "translate(-85.86 -86.78)"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M388.55,177.1l-1.07.41a.49.49,0,1,1-.35-.92h0l1.07-.39h0a.48.48,0,0,1,.62.28A.49.49,0,0,1,388.55,177.1Z",
    transform: "translate(-85.86 -86.78)"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M385,178.45l-1.08.39a.5.5,0,0,1-.65-.3.51.51,0,0,1,.3-.66h0l1.08-.38h0a.49.49,0,0,1,.64.31A.5.5,0,0,1,385,178.45Z",
    transform: "translate(-85.86 -86.78)"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M381.38,179.75l-1.09.38a.53.53,0,1,1-.35-1h0l1.08-.37h0a.53.53,0,0,1,.67.33A.54.54,0,0,1,381.38,179.75Z",
    transform: "translate(-85.86 -86.78)"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M377.77,181l-1.09.36a.54.54,0,0,1-.7-.34.55.55,0,0,1,.34-.71h0l1.09-.35h0a.54.54,0,0,1,.69.35A.56.56,0,0,1,377.77,181Z",
    transform: "translate(-85.86 -86.78)"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M374.14,182.2l-1.09.36a.58.58,0,1,1-.36-1.1h0l1.09-.34h0a.57.57,0,0,1,.72.37A.57.57,0,0,1,374.14,182.2Z",
    transform: "translate(-85.86 -86.78)"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M370.5,183.37l-1.09.34a.6.6,0,1,1-.36-1.14h0l1.09-.33a.58.58,0,0,1,.74.39A.59.59,0,0,1,370.5,183.37Z",
    transform: "translate(-85.86 -86.78)"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M366.85,184.5l-1.1.33a.62.62,0,1,1-.35-1.19h0l1.1-.32a.62.62,0,0,1,.35,1.18Z",
    transform: "translate(-85.86 -86.78)"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M363.19,185.59l-1.1.32a.64.64,0,1,1-.36-1.23h0l1.1-.31a.62.62,0,0,1,.78.44A.63.63,0,0,1,363.19,185.59Z",
    transform: "translate(-85.86 -86.78)"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M359.52,186.65l-1.1.3a.66.66,0,1,1-.36-1.26h0l1.1-.3a.64.64,0,0,1,.8.45A.66.66,0,0,1,359.52,186.65Z",
    transform: "translate(-85.86 -86.78)"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M355.84,187.66l-1.11.3a.67.67,0,0,1-.35-1.29h0l1.1-.29a.66.66,0,1,1,.35,1.28Z",
    transform: "translate(-85.86 -86.78)"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M352.15,188.66,351,189a.68.68,0,0,1-.83-.49.69.69,0,0,1,.48-.84h0l1.11-.28a.68.68,0,0,1,.83.49A.69.69,0,0,1,352.15,188.66Z",
    transform: "translate(-85.86 -86.78)"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M348.46,189.62l-1.12.29a.69.69,0,0,1-.84-.5.68.68,0,0,1,.5-.85h0l1.11-.27a.69.69,0,1,1,.35,1.34Z",
    transform: "translate(-85.86 -86.78)"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M344.75,190.57l-1.11.27a.71.71,0,1,1-.34-1.37h0l1.11-.27a.71.71,0,0,1,.34,1.38Z",
    transform: "translate(-85.86 -86.78)"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M341.05,191.49l-1.12.27a.72.72,0,0,1-.34-1.4h0l1.12-.26a.72.72,0,1,1,.34,1.4Z",
    transform: "translate(-85.86 -86.78)"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M337.34,192.39l-1.12.27a.73.73,0,1,1-.34-1.43h0L337,191a.73.73,0,0,1,.34,1.42Z",
    transform: "translate(-85.86 -86.78)"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M333.63,193.28l-1.12.27a.75.75,0,0,1-.35-1.46h0l1.11-.26a.75.75,0,0,1,.35,1.45Z",
    transform: "translate(-85.86 -86.78)"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M329.91,194.16l-1.11.26a.76.76,0,1,1-.35-1.48h0l1.12-.26a.76.76,0,0,1,.34,1.48Z",
    transform: "translate(-85.86 -86.78)"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M326.19,195l-1.11.26a.78.78,0,0,1-.35-1.51h0l1.12-.25a.77.77,0,0,1,.34,1.51Z",
    transform: "translate(-85.86 -86.78)"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M322.48,195.89l-1.12.26a.79.79,0,1,1-.36-1.54h0l1.12-.25a.78.78,0,1,1,.35,1.53Z",
    transform: "translate(-85.86 -86.78)"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M318.76,196.75l-1.12.26a.82.82,0,0,1-1-.61.8.8,0,0,1,.6-1h0l1.11-.25a.8.8,0,0,1,1,.61A.8.8,0,0,1,318.76,196.75Z",
    transform: "translate(-85.86 -86.78)"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M315,197.6l-1.12.26a.82.82,0,1,1-.36-1.59h0l1.12-.25a.81.81,0,1,1,.36,1.58Z",
    transform: "translate(-85.86 -86.78)"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M311.32,198.46l-1.12.26a.83.83,0,0,1-.37-1.62h0l1.11-.25a.83.83,0,0,1,.37,1.61Z",
    transform: "translate(-85.86 -86.78)"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M307.6,199.32l-1.11.26a.84.84,0,0,1-1-.63.83.83,0,0,1,.62-1h0l1.12-.25a.84.84,0,0,1,.37,1.64Z",
    transform: "translate(-85.86 -86.78)"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M303.89,200.19l-1.11.26a.86.86,0,0,1-.4-1.67h0l1.12-.26a.86.86,0,0,1,.38,1.67Z",
    transform: "translate(-85.86 -86.78)"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M300.18,201.06l-1.11.27a.87.87,0,1,1-.41-1.69h0l1.11-.26a.86.86,0,0,1,.4,1.68Z",
    transform: "translate(-85.86 -86.78)"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M296.47,202l-1.11.27a.88.88,0,0,1-.42-1.71h0l1.12-.27a.88.88,0,0,1,.4,1.71Z",
    transform: "translate(-85.86 -86.78)"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M292.77,202.86l-1.11.28a.9.9,0,0,1-.43-1.74h0l1.11-.26a.89.89,0,1,1,.42,1.73Z",
    transform: "translate(-85.86 -86.78)"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M289.08,203.78l-1.11.29a.91.91,0,1,1-.45-1.77h0l1.11-.27a.9.9,0,1,1,.44,1.75Z",
    transform: "translate(-85.86 -86.78)"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M285.39,204.73l-1.11.29a.93.93,0,0,1-.47-1.79h0l1.11-.28a.92.92,0,0,1,.46,1.78Z",
    transform: "translate(-85.86 -86.78)"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M281.7,205.7l-1.1.29h0a.93.93,0,1,1-.48-1.8h0l1.11-.29a.93.93,0,1,1,.47,1.8Z",
    transform: "translate(-85.86 -86.78)"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M278,206.68l-1.11.31h0a.94.94,0,0,1-.49-1.82h0l1.11-.3a.94.94,0,0,1,.49,1.81Z",
    transform: "translate(-85.86 -86.78)"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M274.36,207.7l-1.1.31h0a.95.95,0,0,1-.52-1.82h0l1.1-.31a.95.95,0,0,1,.51,1.82Z",
    transform: "translate(-85.86 -86.78)"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M270.7,208.74l-1.1.32h0a.95.95,0,1,1-.53-1.82h0l1.1-.32a1,1,0,0,1,1.17.65.94.94,0,0,1-.64,1.17Z",
    transform: "translate(-85.86 -86.78)"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M267.05,209.82l-1.1.33h0a1,1,0,1,1-.55-1.82h0l1.1-.33a1,1,0,1,1,.55,1.82Z",
    transform: "translate(-85.86 -86.78)"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M263.41,210.93l-1.09.34h0a1,1,0,0,1-.58-1.82h0l1.09-.34a1,1,0,0,1,1.2.63,1,1,0,0,1-.63,1.19Z",
    transform: "translate(-85.86 -86.78)"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M259.78,212.08l-1.08.35h0a1,1,0,1,1-.59-1.82h0l1.09-.36a1,1,0,1,1,.59,1.83Z",
    transform: "translate(-85.86 -86.78)"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M256.17,213.27l-1.08.37h0a1,1,0,1,1-.62-1.83h0l1.09-.37a1,1,0,0,1,1.22.61,1,1,0,0,1-.61,1.22Z",
    transform: "translate(-85.86 -86.78)"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M252.57,214.51l-1.07.37h0a1,1,0,0,1-1.23-.6,1,1,0,0,1,.59-1.23h0l1.08-.38a1,1,0,1,1,.64,1.82Z",
    transform: "translate(-85.86 -86.78)"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M249,215.78l-1.07.4h0a1,1,0,0,1-.67-1.83h0l1.08-.39a1,1,0,0,1,.66,1.82Z",
    transform: "translate(-85.86 -86.78)"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M245.43,217.11l-1.06.41h0a1,1,0,0,1-1.26-.56,1,1,0,0,1,.56-1.27h0l1.08-.41a1,1,0,1,1,.69,1.83Z",
    transform: "translate(-85.86 -86.78)"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M241.89,218.49l-1.06.42h0a1,1,0,1,1-.73-1.82h0l1.07-.43a1,1,0,0,1,.72,1.83Z",
    transform: "translate(-85.86 -86.78)"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M238.37,219.92l-1.05.44h0a1,1,0,1,1-.76-1.82h0l1.06-.44a1,1,0,0,1,.76,1.82Z",
    transform: "translate(-85.86 -86.78)"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M234.87,221.41l-1,.45h0a1,1,0,0,1-.79-1.82h0l1.06-.46a1,1,0,1,1,.79,1.81Z",
    transform: "translate(-85.86 -86.78)"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M231.4,223l-1,.48h0a1,1,0,0,1-.83-1.81h0l1.05-.48a1,1,0,0,1,1.32.49,1,1,0,0,1-.5,1.32Z",
    transform: "translate(-85.86 -86.78)"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M228,224.55l-1,.5h0a1,1,0,1,1-.87-1.8h0l1-.5a1,1,0,1,1,.86,1.8Z",
    transform: "translate(-85.86 -86.78)"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M224.55,226.22l-1,.51h0a1,1,0,1,1-.9-1.79h0l1-.52a1,1,0,0,1,1.35.45,1,1,0,0,1-.45,1.35Z",
    transform: "translate(-85.86 -86.78)"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M221.17,228l-1,.53h0a1,1,0,0,1-.94-1.78h0l1-.54a1,1,0,0,1,.94,1.79Z",
    transform: "translate(-85.86 -86.78)"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M217.83,229.75l-1,.55h0a1,1,0,1,1-1-1.77h0l1-.56a1,1,0,1,1,1,1.77Z",
    transform: "translate(-85.86 -86.78)"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M214.53,231.61l-1,.57h0a1,1,0,0,1-1.39-.37,1,1,0,0,1,.36-1.39h0l1-.58a1,1,0,1,1,1,1.76Z",
    transform: "translate(-85.86 -86.78)"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M211.27,233.54l-1,.6h0a1,1,0,1,1-1.07-1.74h0l1-.6a1,1,0,1,1,1.06,1.74Z",
    transform: "translate(-85.86 -86.78)"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M208.05,235.55l-1,.61h0a1,1,0,0,1-1.12-1.73h0l1-.62a1,1,0,0,1,1.41.31,1,1,0,0,1-.31,1.42Z",
    transform: "translate(-85.86 -86.78)"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M204.88,237.63l-.94.63h0a1,1,0,0,1-1.16-1.71h0l.95-.64a1,1,0,1,1,1.15,1.7Z",
    transform: "translate(-85.86 -86.78)"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M201.76,239.78l-.93.66h0a1,1,0,1,1-1.21-1.69h0l.93-.66a1,1,0,0,1,1.45.24,1,1,0,0,1-.25,1.44Z",
    transform: "translate(-85.86 -86.78)"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M198.69,242l-.91.68h0a1,1,0,0,1-1.25-1.66h0l.92-.7A1,1,0,0,1,198.7,242Z",
    transform: "translate(-85.86 -86.78)"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M195.69,244.31l-.88.71h0a1,1,0,1,1-1.31-1.62h0l.9-.73a1,1,0,0,1,1.47.17,1,1,0,0,1-.16,1.46Z",
    transform: "translate(-85.86 -86.78)"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M192.78,246.71l-.85.74h0a1,1,0,0,1-1.38-1.58h0l.88-.76a1,1,0,0,1,1.37,1.58Z",
    transform: "translate(-85.86 -86.78)"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M190,249.23l-.82.78h0a1.05,1.05,0,0,1-1.45-1.53h0l.84-.8a1.05,1.05,0,1,1,1.45,1.53Z",
    transform: "translate(-85.86 -86.78)"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M187.3,251.87l-.77.82h0a1.05,1.05,0,1,1-1.53-1.45h0l.8-.85a1.06,1.06,0,0,1,1.53,1.46Z",
    transform: "translate(-85.86 -86.78)"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M184.78,254.65l-.73.86h0a1.06,1.06,0,0,1-1.63-1.36h0l.75-.89a1.06,1.06,0,1,1,1.62,1.36Z",
    transform: "translate(-85.86 -86.78)"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M182.44,257.57l-.67.9v0a1.06,1.06,0,0,1-1.71-1.25l.68-.94a1.06,1.06,0,1,1,1.72,1.25h0Z",
    transform: "translate(-85.86 -86.78)"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M180.31,260.64l-.59.95v0a1.06,1.06,0,1,1-1.8-1.11l.61-1a1.06,1.06,0,0,1,1.81,1.11h0Z",
    transform: "translate(-85.86 -86.78)"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M178.45,263.86l-.5,1v0a1.07,1.07,0,0,1-1.42.46,1,1,0,0,1-.47-1.41l.53-1.05a1.06,1.06,0,0,1,1.89.94h0Z",
    transform: "translate(-85.86 -86.78)"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M176.9,267.23l-.4,1,0,0a1,1,0,0,1-1.95-.75l.42-1.1a1,1,0,1,1,2,.75h0Z",
    transform: "translate(-85.86 -86.78)"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M175.69,270.74l-.29,1.07v0a1,1,0,1,1-2-.54l.31-1.14a1,1,0,1,1,2,.54h0Z",
    transform: "translate(-85.86 -86.78)"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M174.86,274.34l-.16,1.1v0a1,1,0,0,1-2.06-.31l.18-1.17a1,1,0,0,1,2.06.31h0Z",
    transform: "translate(-85.86 -86.78)"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M174.45,278l0,1.11v0a1,1,0,0,1-1.08,1,1,1,0,0,1-1-1.08l0-1.17a1,1,0,0,1,2.08.08h0Z",
    transform: "translate(-85.86 -86.78)"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M174.43,281.72l.07,1.11v0a1,1,0,1,1-2.06.13l-.08-1.17a1,1,0,0,1,1-1.1,1,1,0,0,1,1.1,1h0Z",
    transform: "translate(-85.86 -86.78)"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M174.79,285.41l.18,1.1v0a1,1,0,1,1-2,.33l-.19-1.16a1,1,0,0,1,2-.33h0Z",
    transform: "translate(-85.86 -86.78)"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M175.51,289.06l.28,1.08v0a1,1,0,0,1-.73,1.25,1,1,0,0,1-1.25-.74l-.3-1.13a1,1,0,0,1,2-.52h0Z",
    transform: "translate(-85.86 -86.78)"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M176.55,292.63l.37,1.06v0a1,1,0,0,1-1.92.69l-.4-1.11a1,1,0,0,1,1.93-.68h0Z",
    transform: "translate(-85.86 -86.78)"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M177.9,296.11l.46,1v0a1,1,0,1,1-1.86.84l-.48-1.06a1,1,0,0,1,1.86-.84h0Z",
    transform: "translate(-85.86 -86.78)"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M179.53,299.47l.53,1,0,0a1,1,0,1,1-1.78,1l-.56-1a1,1,0,1,1,1.77-1h0Z",
    transform: "translate(-85.86 -86.78)"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M181.41,302.69l.62.94v0a1,1,0,0,1-1.69,1.11l-.64-1a1,1,0,0,1,.29-1.4,1,1,0,0,1,1.4.29h0Z",
    transform: "translate(-85.86 -86.78)"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M183.54,305.77l.68.89h0a1,1,0,0,1-1.6,1.23l-.71-.92a1,1,0,1,1,1.6-1.23h0Z",
    transform: "translate(-85.86 -86.78)"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M185.89,308.67l.75.83,0,0a1,1,0,0,1-1.49,1.34l-.78-.87a1,1,0,0,1,.07-1.41,1,1,0,0,1,1.42.07h0Z",
    transform: "translate(-85.86 -86.78)"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M188.46,311.39l.81.79h0a1,1,0,0,1-1.39,1.43l-.83-.81a1,1,0,0,1,0-1.41,1,1,0,0,1,1.41,0h0Z",
    transform: "translate(-85.86 -86.78)"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M191.21,314l.85.73h0a1,1,0,0,1,.1,1.4,1,1,0,0,1-1.39.11l-.89-.75a1,1,0,0,1,1.29-1.51h0Z",
    transform: "translate(-85.86 -86.78)"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M194.11,316.33l.9.69h0a1,1,0,1,1-1.2,1.57l-.92-.7a1,1,0,0,1,1.19-1.58h0Z",
    transform: "translate(-85.86 -86.78)"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M197.14,318.55l.94.64h0a1,1,0,0,1-1.1,1.64l-1-.65a1,1,0,0,1,1.1-1.64h0Z",
    transform: "translate(-85.86 -86.78)"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M200.3,320.61l1,.59h0a1,1,0,0,1-1,1.68l-1-.6a1,1,0,0,1,1-1.68h0Z",
    transform: "translate(-85.86 -86.78)"
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M203.55,322.51l1,.54h0a1,1,0,0,1-.93,1.72l-1-.56a1,1,0,1,1,.94-1.71h0Z",
    transform: "translate(-85.86 -86.78)"
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M206.89,324.27l1,.5h0a1,1,0,1,1-.86,1.74l-1-.5a1,1,0,1,1,.86-1.75h0Z",
    transform: "translate(-85.86 -86.78)"
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M210.3,325.9l1,.46h0a1,1,0,1,1-.79,1.77l-1.05-.47a1,1,0,0,1,.79-1.78h0Z",
    transform: "translate(-85.86 -86.78)"
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M213.77,327.4l1,.43h0a1,1,0,1,1-.73,1.78l-1.07-.43a1,1,0,1,1,.73-1.79h0Z",
    transform: "translate(-85.86 -86.78)"
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M217.29,328.79l1.06.4h0a1,1,0,0,1,.57,1.24,1,1,0,0,1-1.24.56l-1.08-.4a1,1,0,0,1-.57-1.23,1,1,0,0,1,1.24-.57h0Z",
    transform: "translate(-85.86 -86.78)"
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M220.85,330.08l1.08.37h0a1,1,0,0,1,.59,1.22,1,1,0,0,1-1.21.59l-1.09-.37a1,1,0,0,1,.61-1.81Z",
    transform: "translate(-85.86 -86.78)"
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M224.45,331.28l1.08.34h0a1,1,0,0,1-.57,1.82l-1.1-.35a.94.94,0,0,1-.62-1.19,1,1,0,0,1,1.19-.63h0Z",
    transform: "translate(-85.86 -86.78)"
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M228.07,332.38l1.1.32h0a1,1,0,0,1-.52,1.83l-1.11-.32a1,1,0,1,1,.53-1.83Z",
    transform: "translate(-85.86 -86.78)"
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M231.73,333.41l1.1.29h0a.95.95,0,0,1-.48,1.83l-1.11-.29a.95.95,0,1,1,.48-1.83h0Z",
    transform: "translate(-85.86 -86.78)"
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M235.4,334.35l1.11.26h0a.93.93,0,0,1,.7,1.13,1,1,0,0,1-1.13.7l-1.12-.27a.94.94,0,1,1,.43-1.83h0Z",
    transform: "translate(-85.86 -86.78)"
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M239.1,335.21l1.11.24h0a.94.94,0,0,1-.4,1.83l-1.13-.24a.94.94,0,1,1,.4-1.84h0Z",
    transform: "translate(-85.86 -86.78)"
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M242.81,336l1.12.22h0a.93.93,0,1,1-.35,1.83l-1.13-.22a.93.93,0,1,1,.35-1.83h0Z",
    transform: "translate(-85.86 -86.78)"
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M246.54,336.69l1.12.19h0a.92.92,0,0,1,.74,1.07.91.91,0,0,1-1,.74l-1.14-.19a.92.92,0,1,1,.31-1.81h0Z",
    transform: "translate(-85.86 -86.78)"
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M250.28,337.32l1.13.17h0a.9.9,0,0,1,.76,1,.91.91,0,0,1-1,.76l-1.13-.17a.91.91,0,0,1,.26-1.8h0Z",
    transform: "translate(-85.86 -86.78)"
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M254,337.87l1.13.15h0a.88.88,0,0,1,.77,1,.9.9,0,0,1-1,.77l-1.14-.15a.89.89,0,0,1,.23-1.77h0Z",
    transform: "translate(-85.86 -86.78)"
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M257.81,338.34l1.13.13h0a.9.9,0,0,1,.78,1,.89.89,0,0,1-1,.78l-1.14-.13a.89.89,0,1,1,.19-1.76h0Z",
    transform: "translate(-85.86 -86.78)"
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M261.58,338.75l1.13.11h0a.86.86,0,0,1,.78.95.87.87,0,0,1-.94.78l-1.14-.1a.87.87,0,1,1,.15-1.74Z",
    transform: "translate(-85.86 -86.78)"
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M265.36,339.09l1.14.08h0a.86.86,0,0,1-.12,1.71l-1.15-.08a.86.86,0,1,1,.12-1.71Z",
    transform: "translate(-85.86 -86.78)"
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M269.15,339.35l1.14.07h0a.85.85,0,1,1-.09,1.69l-1.15-.06a.85.85,0,0,1,.09-1.7Z",
    transform: "translate(-85.86 -86.78)"
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M272.94,339.55l1.14.05h0a.83.83,0,0,1,.79.87.82.82,0,0,1-.86.79l-1.14,0a.82.82,0,0,1-.81-.86.84.84,0,0,1,.86-.81Z",
    transform: "translate(-85.86 -86.78)"
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M276.74,339.69l1.14,0h0a.82.82,0,0,1,.8.84.83.83,0,0,1-.84.8l-1.15,0a.84.84,0,0,1-.81-.84.83.83,0,0,1,.84-.81Z",
    transform: "translate(-85.86 -86.78)"
  })), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M280.54,339.76h1.15a.81.81,0,0,1,0,1.62h-1.15a.81.81,0,0,1-.81-.81.82.82,0,0,1,.82-.81Z",
    transform: "translate(-85.86 -86.78)"
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M284.35,339.77h1.14a.8.8,0,1,1,0,1.6h-1.15a.8.8,0,0,1,0-1.6Z",
    transform: "translate(-85.86 -86.78)"
  })), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M288.15,339.72l1.14,0h0a.78.78,0,0,1,0,1.56l-1.15,0a.79.79,0,0,1-.81-.77.8.8,0,0,1,.76-.81Z",
    transform: "translate(-85.86 -86.78)"
  })), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M292,339.62l1.15-.05h0a.78.78,0,0,1,.06,1.55l-1.15.05a.78.78,0,0,1-.06-1.55Z",
    transform: "translate(-85.86 -86.78)"
  })), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M295.76,339.45l1.14-.06h0a.76.76,0,1,1,.08,1.52l-1.14.07a.77.77,0,1,1-.09-1.53h0Z",
    transform: "translate(-85.86 -86.78)"
  })), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M299.56,339.24l1.13-.08h0a.75.75,0,0,1,.1,1.49l-1.14.09a.76.76,0,0,1-.81-.7.75.75,0,0,1,.7-.8h0Z",
    transform: "translate(-85.86 -86.78)"
  })), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M303.35,339l1.14-.09h0a.74.74,0,0,1,.12,1.47l-1.14.1a.74.74,0,0,1-.13-1.47Z",
    transform: "translate(-85.86 -86.78)"
  })), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M307.14,338.64l1.14-.1h0a.72.72,0,1,1,.14,1.43l-1.14.12a.73.73,0,0,1-.15-1.45Z",
    transform: "translate(-85.86 -86.78)"
  })), _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M310.93,338.26l1.13-.12h0a.71.71,0,0,1,.78.63.72.72,0,0,1-.62.78l-1.14.13a.71.71,0,0,1-.8-.62.73.73,0,0,1,.63-.8h0Z",
    transform: "translate(-85.86 -86.78)"
  })), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M314.71,337.82l1.13-.14h0a.69.69,0,0,1,.78.6.71.71,0,0,1-.6.79l-1.14.15a.7.7,0,0,1-.78-.61.68.68,0,0,1,.6-.78h0Z",
    transform: "translate(-85.86 -86.78)"
  })), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M318.48,337.32l1.13-.16h0a.68.68,0,1,1,.2,1.35l-1.13.18a.7.7,0,0,1-.79-.58.69.69,0,0,1,.58-.79h0Z",
    transform: "translate(-85.86 -86.78)"
  })), _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M322.24,336.75l1.12-.18h0a.67.67,0,0,1,.22,1.33l-1.13.2a.68.68,0,1,1-.23-1.34h0Z",
    transform: "translate(-85.86 -86.78)"
  })), _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M326,336.11l1.12-.21h0a.66.66,0,0,1,.25,1.3l-1.13.22a.67.67,0,0,1-.25-1.31h0Z",
    transform: "translate(-85.86 -86.78)"
  })), _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M329.72,335.39l1.12-.23h0a.65.65,0,0,1,.27,1.27l-1.13.24a.65.65,0,0,1-.27-1.28h0Z",
    transform: "translate(-85.86 -86.78)"
  })), _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M333.44,334.6l1.11-.26h0a.63.63,0,0,1,.29,1.23l-1.12.27a.65.65,0,0,1-.77-.47.64.64,0,0,1,.47-.77h0Z",
    transform: "translate(-85.86 -86.78)"
  })), _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M337.13,333.72l1.11-.28h0a.61.61,0,0,1,.74.45.59.59,0,0,1-.43.73l-1.11.3a.63.63,0,0,1-.76-.44.61.61,0,0,1,.44-.75Z",
    transform: "translate(-85.86 -86.78)"
  })), _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M340.81,332.76l1.1-.3h0a.59.59,0,1,1,.32,1.13l-1.1.32a.6.6,0,0,1-.74-.41.59.59,0,0,1,.41-.73h0Z",
    transform: "translate(-85.86 -86.78)"
  })), _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M344.46,331.71l1.09-.33h0a.56.56,0,0,1,.71.37.57.57,0,0,1-.38.71l-1.09.35a.57.57,0,0,1-.72-.37.58.58,0,0,1,.37-.73Z",
    transform: "translate(-85.86 -86.78)"
  })), _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M348.07,330.55l1.07-.37h0a.55.55,0,0,1,.37,1l-1.08.39a.55.55,0,0,1-.38-1h0Z",
    transform: "translate(-85.86 -86.78)"
  })), _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M351.61,329.22l1-.45h0a.53.53,0,0,1,.7.27.54.54,0,0,1-.28.7l-1.05.47a.54.54,0,0,1-.71-.28.53.53,0,0,1,.27-.7h0Z",
    transform: "translate(-85.86 -86.78)"
  })), _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M355,327.62l1-.54h0a.51.51,0,1,1,.5.89l-1,.57a.53.53,0,0,1-.71-.19.52.52,0,0,1,.2-.71h0Z",
    transform: "translate(-85.86 -86.78)"
  })), _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M358.23,325.68l.91-.66h0a.49.49,0,0,1,.69.1.5.5,0,0,1-.1.69l-.94.69a.5.5,0,0,1-.59-.8h0Z",
    transform: "translate(-85.86 -86.78)"
  })), _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M361.13,323.32l.79-.79,0,0a.47.47,0,0,1,.66,0,.46.46,0,0,1,0,.66l-.82.84a.47.47,0,0,1-.67,0,.49.49,0,0,1,0-.68h0Z",
    transform: "translate(-85.86 -86.78)"
  })), _path204 || (_path204 = /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M363.57,320.52l.61-.94v0a.45.45,0,0,1,.76.49l-.63,1a.45.45,0,0,1-.63.13.44.44,0,0,1-.14-.63h0Z",
    transform: "translate(-85.86 -86.78)"
  })), _path205 || (_path205 = /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M365.38,317.27l.41-1v0a.44.44,0,0,1,.56-.25.43.43,0,0,1,.24.56l-.41,1.09a.45.45,0,0,1-.57.26.44.44,0,0,1-.25-.57h0Z",
    transform: "translate(-85.86 -86.78)"
  })), _path206 || (_path206 = /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M366.48,313.72l.17-1.1v0a.41.41,0,0,1,.47-.34.41.41,0,0,1,.35.46l-.17,1.16a.42.42,0,0,1-.47.36.41.41,0,0,1-.35-.47h0Z",
    transform: "translate(-85.86 -86.78)"
  })), _path207 || (_path207 = /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M366.72,310l-.13-1.1v0a.38.38,0,0,1,.34-.43.39.39,0,0,1,.43.34l.15,1.17a.4.4,0,0,1-.35.44.39.39,0,0,1-.44-.34h0Z",
    transform: "translate(-85.86 -86.78)"
  })), _path208 || (_path208 = /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M365.91,306.44l-.46-1v0a.37.37,0,1,1,.67-.31l.5,1.07a.38.38,0,1,1-.68.32h0Z",
    transform: "translate(-85.86 -86.78)"
  })), _path209 || (_path209 = /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M364,303.34l-.81-.75,0,0a.35.35,0,1,1,.47-.51l.88.8a.35.35,0,0,1-.48.52h0Z",
    transform: "translate(-85.86 -86.78)"
  })), _path210 || (_path210 = /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M361,301.2l-1-.43h0a.32.32,0,0,1,.24-.6l1.09.44a.33.33,0,0,1,.18.43.31.31,0,0,1-.42.18h0Z",
    transform: "translate(-85.86 -86.78)"
  })), _path211 || (_path211 = /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M357.44,300.17l-1.11-.08h0a.29.29,0,1,1,0-.58l1.17.06a.3.3,0,0,1,0,.6h0Z",
    transform: "translate(-85.86 -86.78)"
  })), _path212 || (_path212 = /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M353.76,300.39l-1.05.35h0a.27.27,0,0,1-.34-.17.26.26,0,0,1,.17-.33l1.11-.39a.28.28,0,1,1,.18.52h0Z",
    transform: "translate(-85.86 -86.78)"
  })), _path213 || (_path213 = /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M350.54,302.1a7.28,7.28,0,0,0-.76.81.24.24,0,1,1-.37-.29,7.3,7.3,0,0,1,.79-.88.25.25,0,0,1,.34.36Z",
    transform: "translate(-85.86 -86.78)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgKnowledgeBulb);
export default __webpack_public_path__ + "static/media/knowledge-bulb.d1ff69f8b6a0aafaa0b1053ce3af8b48.svg";
export { ForwardRef as ReactComponent };